function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodbeverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "243.66,213.98 241.68,212.84 238.88,212.84 236.9,213.98 236.9,215.6 238.88,216.74  241.68,216.74 243.66,215.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.88,
    y: 216.74,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.8,
    height: 1.91
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "243.66,217.52 241.68,218.66 241.68,216.74 243.66,215.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "236.9,217.52 238.88,218.66 238.88,216.74 236.9,215.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "242.95,190.13 241.39,189.22 239.16,189.22 237.6,190.13 237.6,191.41 239.16,192.31  241.39,192.31 242.95,191.41  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.16,
    y: 192.31,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.22,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "242.95,215.34 241.39,216.24 241.39,192.31 242.95,191.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "237.6,215.34 239.16,216.24 239.16,192.31 237.6,191.41  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "288.51,213.98 286.53,212.84 283.73,212.84 281.75,213.98 281.75,215.6  283.73,216.74 286.53,216.74 288.51,215.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.73,
    y: 216.74,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.8,
    height: 1.91
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "288.51,217.52 286.53,218.66 286.53,216.74 288.51,215.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "281.75,217.52 283.73,218.66 283.73,216.74 281.75,215.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "287.81,190.13 286.24,189.22 284.02,189.22 282.46,190.13 282.46,191.41  284.02,192.31 286.24,192.31 287.81,191.41  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.02,
    y: 192.31,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.22,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "287.81,215.34 286.24,216.24 286.24,192.31 287.81,191.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "282.46,215.34 284.02,216.24 284.02,192.31 282.46,191.41  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "320.26,195.65 318.28,194.51 315.48,194.51 313.5,195.65 313.5,197.27 315.48,198.41  318.28,198.41 320.26,197.27  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.48,
    y: 198.41,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.8,
    height: 1.92
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "320.26,199.18 318.28,200.33 318.28,198.41 320.26,197.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "313.5,199.18 315.48,200.33 315.48,198.41 313.5,197.27  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "319.55,171.8 317.99,170.89 315.77,170.89 314.21,171.8 314.21,173.08 315.77,173.98  317.99,173.98 319.55,173.08  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.77,
    y: 173.98,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.22,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "319.55,197 317.99,197.91 317.99,173.98 319.55,173.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "314.21,197 315.77,197.91 315.77,173.98 314.21,173.08  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "211.91,195.65 209.93,194.51 207.13,194.51 205.15,195.65 205.15,197.27  207.13,198.41 209.93,198.41 211.91,197.27  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.13,
    y: 198.41,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.8,
    height: 1.92
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "211.91,199.18 209.93,200.33 209.93,198.41 211.91,197.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "205.15,199.18 207.13,200.33 207.13,198.41 205.15,197.27  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "211.2,171.8 209.64,170.89 207.42,170.89 205.85,171.8 205.85,173.08 207.42,173.98  209.64,173.98 211.2,173.08  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.42,
    y: 173.98,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.21,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "211.2,197 209.64,197.91 209.64,173.98 211.2,173.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "205.85,197 207.42,197.91 207.42,173.98 205.85,173.08  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "320.31,171.62 286.56,152.13 238.84,152.13 205.1,171.62 205.1,199.17 238.84,218.66  286.56,218.66 320.31,199.17  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "319.94,146.33 286.42,126.97 238.99,126.97 205.47,146.33 205.47,173.71 238.99,193.07  286.42,193.07 319.94,173.71  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.99,
    y: 193.07,
    style: {
      fill: "#B5AFA7"
    },
    width: 47.42,
    height: 3.43
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "319.94,177.16 286.42,196.51 286.42,193.07 319.94,173.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "205.47,177.16 238.99,196.51 238.99,193.07 205.47,173.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "316.88,79.72 316.88,172.48 285.13,190.77 273.92,91.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "285.13,98.07 285.13,190.77 240.28,190.77 208.53,79.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "240.28,98.07 240.28,190.77 208.51,172.48 208.53,79.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "280.13,77.35 245.31,77.35 240.28,98.07 285.13,98.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "304.77,63.12 280.13,77.35 285.13,98.07 316.88,79.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "304.77,43 304.77,63.12 316.88,79.72 316.91,53.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "245.31,77.35 220.65,63.12 208.53,79.73 240.28,98.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "220.65,63.12 220.64,43 208.51,53.81 208.53,79.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDE8E3"
    },
    points: "280.13,28.79 245.31,28.79 220.64,43 220.65,63.12 245.31,77.35 280.13,77.35  304.77,63.12 304.77,43  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "330.05,263.85 328.07,262.7 325.28,262.7 323.29,263.85 323.29,265.46 325.28,266.6  328.07,266.6 330.05,265.46  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.28,
    y: 266.6,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.8,
    height: 1.91
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "330.05,267.38 328.07,268.51 328.07,266.6 330.05,265.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "323.29,267.38 325.28,268.51 325.28,266.6 323.29,265.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "329.35,239.99 327.78,239.08 325.57,239.08 324,239.99 324,241.27 325.57,242.17  327.78,242.18 329.35,241.27  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.57,
    y: 242.17,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.21,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "329.35,265.19 327.78,266.1 327.78,242.17 329.35,241.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "324,265.19 325.57,266.1 325.57,242.17 324,241.27  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "374.91,263.85 372.93,262.7 370.13,262.7 368.15,263.85 368.15,265.46 370.13,266.6  372.93,266.6 374.91,265.46  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.13,
    y: 266.6,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.8,
    height: 1.91
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "374.91,267.38 372.93,268.51 372.93,266.6 374.91,265.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "368.15,267.38 370.13,268.51 370.13,266.6 368.15,265.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "374.2,239.99 372.64,239.08 370.42,239.08 368.86,239.99 368.86,241.27  370.42,242.17 372.64,242.18 374.2,241.27  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.42,
    y: 242.17,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.21,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "374.2,265.19 372.64,266.1 372.64,242.17 374.2,241.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "368.86,265.19 370.42,266.1 370.42,242.17 368.86,241.27  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "406.66,245.51 404.67,244.37 401.88,244.37 399.9,245.51 399.9,247.13 401.88,248.27  404.67,248.27 406.66,247.13  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.88,
    y: 248.27,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.79,
    height: 1.92
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "406.66,249.04 404.67,250.19 404.67,248.27 406.66,247.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "399.9,249.04 401.88,250.19 401.88,248.27 399.9,247.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "405.95,221.65 404.38,220.75 402.17,220.75 400.6,221.65 400.6,222.94 402.17,223.84  404.38,223.84 405.95,222.94  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.17,
    y: 223.84,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.21,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "405.95,246.87 404.38,247.77 404.38,223.84 405.95,222.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "400.6,246.87 402.17,247.77 402.17,223.84 400.6,222.94  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "298.3,245.51 296.33,244.37 293.53,244.37 291.55,245.51 291.55,247.13  293.53,248.27 296.33,248.27 298.3,247.13  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.53,
    y: 248.27,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.8,
    height: 1.92
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "298.3,249.04 296.33,250.19 296.33,248.27 298.3,247.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "291.55,249.04 293.53,250.19 293.53,248.27 291.55,247.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "297.6,221.65 296.04,220.75 293.82,220.75 292.25,221.65 292.25,222.94  293.82,223.84 296.04,223.84 297.6,222.94  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.82,
    y: 223.84,
    style: {
      fill: "#B5AFA7"
    },
    width: 2.22,
    height: 23.93
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "297.6,246.87 296.04,247.77 296.04,223.84 297.6,222.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "292.25,246.87 293.82,247.77 293.82,223.84 292.25,222.94  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "406.7,221.48 372.97,201.99 325.24,201.99 291.5,221.48 291.5,249.03 325.24,268.51  372.97,268.51 406.7,249.03  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "406.33,196.19 372.81,176.83 325.39,176.83 291.87,196.19 291.87,223.57 325.39,242.93  372.81,242.93 406.33,223.57  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.39,
    y: 242.93,
    style: {
      fill: "#B5AFA7"
    },
    width: 47.42,
    height: 3.43
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "406.33,227.01 372.81,246.36 372.81,242.93 406.33,223.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "291.87,227.01 325.39,246.36 325.39,242.93 291.87,223.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "403.28,140.88 403.28,222.34 371.53,240.63 360.32,152.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "371.53,159.22 371.53,240.63 326.67,240.63 294.92,140.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "326.67,159.22 326.67,240.63 294.91,222.34 294.92,140.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "366.53,138.51 331.7,138.51 326.67,159.22 371.53,159.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "391.17,124.28 366.53,138.51 371.53,159.22 403.28,140.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "391.17,104.16 391.17,124.28 403.28,140.88 403.31,114.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "331.7,138.51 307.05,124.28 294.92,140.9 326.67,159.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "307.05,124.28 307.04,104.16 294.91,114.97 294.92,140.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDE8E3"
    },
    points: "366.53,89.94 331.7,89.94 307.04,104.16 307.05,124.28 331.7,138.51 366.53,138.51  391.17,124.28 391.17,104.16  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "220.23,218.04 192.13,201.81 152.38,201.81 124.27,218.04 124.27,241 152.38,257.23  192.13,257.23 220.23,241  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.38,
    y: 257.23,
    style: {
      fill: "#B5AFA7"
    },
    width: 39.75,
    height: 8.1
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "220.23,249.12 192.13,265.34 192.13,257.23 220.23,241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "124.27,249.12 152.38,265.34 152.38,257.23 124.27,241  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "216.82,150.08 190.71,135 153.79,135 127.68,150.08 127.68,171.4 153.79,186.47  190.71,186.47 216.82,171.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.79,
    y: 186.47,
    style: {
      fill: "#B5AFA7"
    },
    width: 36.92,
    height: 67.71
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "216.82,239.12 190.71,254.18 190.71,186.47 216.82,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "127.68,239.12 153.79,254.18 153.79,186.47 127.68,171.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "186.24,145.68 186.24,146.72 183.01,148.58 181.87,146.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "183.01,147.53 183.01,148.58 178.44,148.58 175.22,145.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "178.44,147.53 178.44,148.58 175.22,146.72 175.22,145.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "175.22,143.04 175.22,145.68 178.44,147.53 183.01,147.53 186.24,145.68  186.24,143.04 183.02,141.18 178.44,141.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "182.67,124.18 182.11,128.59 182.67,146.78 185.4,145.21 185.4,125.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "178.8,121.96 177.75,128.26 178.8,146.78 182.67,146.78 182.66,124.18 182.29,121.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "178.8,121.96 178.8,146.78 176.06,145.21 176.07,120.38 178.42,120.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "212.82,98.2 213.72,97.68 216.95,99.54 216.01,101.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "216.04,100.06 216.95,99.54 219.23,103.49 218.32,107.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "218.32,104.01 219.23,103.49 219.23,107.22 218.32,107.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "216.04,109.05 218.32,107.74 218.32,104.01 216.04,100.06 212.82,98.2 210.53,99.52  210.53,103.24 212.82,107.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "176.07,120.38 212.83,99.16 215.56,100.74 178.8,121.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "178.8,121.96 215.56,100.74 217.5,104.09 211.78,109.48 182.67,124.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "182.67,124.18 217.5,104.09 217.5,107.25 185.4,125.75 184.07,126.69  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "204.45,156.17 204.45,157.22 201.22,159.08 200.08,157.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "201.22,158.03 201.22,159.08 196.65,159.08 193.43,156.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "196.65,158.03 196.65,159.08 193.43,157.22 193.43,156.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "193.43,153.54 193.43,156.17 196.65,158.03 201.22,158.03 204.45,156.17  204.45,153.54 201.22,151.67 196.65,151.67  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "200.87,134.68 200.31,139.08 200.87,157.28 203.61,155.71 203.61,136.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "197,132.45 195.96,138.75 197,157.28 200.87,157.28 200.87,134.68 200.5,132.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "197,132.45 197,157.28 194.27,155.71 194.28,130.88 196.63,131.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "231.02,108.69 231.93,108.17 235.16,110.04 234.22,111.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "234.25,110.56 235.16,110.04 237.44,113.99 236.53,118.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "236.53,114.5 237.44,113.99 237.44,117.71 236.53,118.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "234.25,119.55 236.53,118.23 236.53,114.5 234.25,110.55 231.02,108.69  228.74,110.01 228.74,113.73 231.02,117.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "194.28,130.88 231.04,109.65 233.77,111.23 197,132.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "197,132.45 233.77,111.23 235.71,114.59 229.99,119.98 200.87,134.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "200.87,134.68 235.71,114.59 235.71,117.74 203.61,136.25 202.28,137.19  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "378.79,267.2 387.11,272 411.42,185.99 378.79,195.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "387.11,200.03 411.42,185.99 403.1,181.18 378.79,195.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "387.11,272 411.42,257.96 411.42,185.99 387.11,200.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "410.25,188.44 410.25,203.58 401.65,208.54 401.65,208.2 409.95,203.4 409.95,188.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#736656"
    },
    points: "409.95,188.62 409.95,203.4 401.65,208.2 401.65,193.42  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "402.18,193.75 402.18,195 404.65,193.58 404.65,192.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3D791"
    },
    points: "402.18,197.45 404.65,196.03 404.65,194.77 402.18,196.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "402.18,199.9 404.65,198.47 404.65,197.22 402.18,198.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB9D67"
    },
    points: "402.18,202.34 404.65,200.92 404.65,199.67 402.18,201.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "402.18,204.79 404.65,203.36 404.65,202.11 402.18,203.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "402.18,207.24 404.65,205.81 404.65,204.56 402.18,205.99  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#574943"
    },
    points: "407.04,190.94 407.04,192.2 409.52,190.77 409.52,189.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#574943"
    },
    points: "407.04,194.64 409.52,193.22 409.52,191.96 407.04,193.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8CCCCB"
    },
    points: "407.04,197.09 409.52,195.67 409.52,194.41 407.04,195.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D18067"
    },
    points: "407.04,199.54 409.52,198.11 409.52,196.86 407.04,198.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "407.04,201.98 409.52,200.56 409.52,199.31 407.04,200.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "407.04,204.43 409.52,203.01 409.52,201.75 407.04,203.17  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "389.29,216.94 390.21,217.48 401.21,194.24 389.29,200.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "390.21,200.59 401.21,194.24 400.28,193.7 389.29,200.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "390.21,217.48 401.21,211.13 401.21,194.24 390.21,200.59  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "399.99,196.18 399.99,200.31 391.39,205.26 391.39,204.93 399.69,200.13  399.69,196.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#736656"
    },
    points: "399.69,196.36 399.69,200.13 391.39,204.93 391.39,201.15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#574943"
    },
    points: "399.99,201.57 399.99,210.58 391.39,215.54 391.39,215.2 399.69,210.41 399.69,201.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#362C29"
    },
    points: "399.69,201.74 399.69,210.41 391.39,215.2 391.39,206.53  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "393.24,206.35 393.1,206.26 392.52,206.6 392.67,206.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "392.67,206.68 392.52,206.6 392.12,207.3 392.26,208.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "392.26,207.38 392.12,207.3 392.12,207.96 392.26,208.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "392.67,208.29 392.26,208.04 392.26,207.38 392.67,206.68 393.24,206.34  393.65,206.58 393.65,207.24 393.24,207.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FA5C52"
    },
    points: "393.71,206.84 393.22,206.56 392.76,206.82 393.25,207.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C84030"
    },
    points: "393.25,207.1 392.76,206.82 392.44,207.39 392.92,208.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB281F"
    },
    points: "392.92,207.67 392.44,207.39 392.44,207.92 392.92,208.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A1C14"
    },
    points: "393.25,208.39 392.92,208.2 392.92,207.67 393.25,207.1 393.71,206.84 394.03,207.03  394.03,207.56 393.71,208.12  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "395.93,204.79 395.78,204.71 395.21,205.03 395.35,205.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "395.35,205.12 395.21,205.03 394.8,205.75 394.95,206.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "394.95,205.84 394.8,205.75 394.8,206.41 394.95,206.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "395.35,206.73 394.95,206.49 394.95,205.84 395.35,205.12 395.93,204.79  396.34,205.02 396.34,205.69 395.93,206.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "396.4,205.29 395.91,205 395.44,205.27 395.94,205.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "395.93,205.55 395.44,205.27 395.12,205.84 395.61,206.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "395.61,206.12 395.12,205.84 395.12,206.37 395.61,206.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "395.93,206.84 395.61,206.65 395.61,206.12 395.93,205.55 396.4,205.29  396.72,205.47 396.72,206.01 396.4,206.57  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "398.62,203.23 398.48,203.15 397.9,203.49 398.05,203.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "398.04,203.57 397.9,203.49 397.49,204.19 397.64,204.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "397.64,204.28 397.49,204.19 397.49,204.85 397.64,204.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "398.04,205.18 397.64,204.94 397.64,204.28 398.04,203.57 398.62,203.23  399.03,203.47 399.03,204.14 398.62,204.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8F3FF"
    },
    points: "399.09,203.73 398.59,203.45 398.14,203.72 398.62,204.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8DFE8"
    },
    points: "398.62,204 398.14,203.72 397.81,204.28 398.3,205.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4CED6"
    },
    points: "398.3,204.56 397.81,204.28 397.81,204.81 398.3,205.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A1B4BF"
    },
    points: "398.62,205.28 398.3,205.09 398.3,204.56 398.62,204 399.09,203.73 399.41,203.92  399.41,204.45 399.09,205.02  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "393.24,208.79 393.1,208.71 392.52,209.04 392.67,209.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "392.67,209.12 392.52,209.04 392.12,209.74 392.26,210.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "392.26,209.83 392.12,209.74 392.12,210.41 392.26,210.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "392.67,210.73 392.26,210.49 392.26,209.83 392.67,209.12 393.24,208.78  393.65,209.03 393.65,209.69 393.24,210.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FA5C52"
    },
    points: "393.71,209.29 393.22,209.01 392.76,209.27 393.25,209.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C84030"
    },
    points: "393.25,209.55 392.76,209.27 392.44,209.83 392.92,210.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB281F"
    },
    points: "392.92,210.11 392.44,209.83 392.44,210.37 392.92,210.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A1C14"
    },
    points: "393.25,210.83 392.92,210.65 392.92,210.11 393.25,209.55 393.71,209.29  394.03,209.47 394.03,210 393.71,210.57  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "395.93,207.24 395.78,207.16 395.21,207.49 395.35,207.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "395.35,207.57 395.21,207.49 394.8,208.2 394.95,208.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "394.95,208.28 394.8,208.2 394.8,208.86 394.95,208.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "395.35,209.18 394.95,208.94 394.95,208.28 395.35,207.57 395.93,207.24  396.34,207.47 396.34,208.14 395.93,208.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "396.4,207.73 395.91,207.45 395.44,207.72 395.94,208.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "395.93,208 395.44,207.72 395.12,208.29 395.61,209.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "395.61,208.57 395.12,208.29 395.12,208.82 395.61,209.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "395.93,209.28 395.61,209.1 395.61,208.57 395.93,208 396.4,207.73 396.72,207.92  396.72,208.46 396.4,209.02  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "398.62,205.68 398.48,205.59 397.9,205.94 398.05,206.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "398.04,206.02 397.9,205.94 397.49,206.64 397.64,207.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "397.64,206.73 397.49,206.64 397.49,207.3 397.64,207.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "398.04,207.63 397.64,207.39 397.64,206.73 398.04,206.02 398.62,205.68  399.03,205.92 399.03,206.59 398.62,207.29  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "399.09,206.18 398.59,205.9 398.14,206.17 398.62,206.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "398.62,206.45 398.14,206.17 397.81,206.73 398.3,207.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "398.3,207.01 397.81,206.73 397.81,207.27 398.3,207.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "398.62,207.73 398.3,207.54 398.3,207.01 398.62,206.45 399.09,206.18 399.41,206.37  399.41,206.9 399.09,207.47  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "393.24,211.23 393.1,211.15 392.52,211.49 392.67,211.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "392.67,211.57 392.52,211.49 392.12,212.19 392.26,212.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "392.26,212.28 392.12,212.19 392.12,212.86 392.26,212.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "392.67,213.18 392.26,212.94 392.26,212.28 392.67,211.57 393.24,211.23  393.65,211.48 393.65,212.14 393.24,212.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "393.71,211.73 393.22,211.45 392.76,211.72 393.25,212.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "393.25,212 392.76,211.72 392.44,212.28 392.92,213.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "392.92,212.56 392.44,212.28 392.44,212.81 392.92,213.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5F9FAD"
    },
    points: "393.25,213.28 392.92,213.1 392.92,212.56 393.25,212 393.71,211.73 394.03,211.92  394.03,212.45 393.71,213.02  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "395.93,209.68 395.78,209.61 395.21,209.94 395.35,210.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "395.35,210.02 395.21,209.94 394.81,210.64 394.95,211.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "394.95,210.72 394.81,210.64 394.81,211.3 394.95,211.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "395.35,211.63 394.95,211.39 394.95,210.72 395.35,210.02 395.93,209.68  396.34,209.93 396.34,210.59 395.93,211.29  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "396.4,210.18 395.9,209.9 395.45,210.17 395.94,210.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "395.93,210.45 395.45,210.17 395.12,210.73 395.6,211.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "395.6,211.01 395.12,210.73 395.12,211.26 395.6,211.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5F9FAD"
    },
    points: "395.93,211.73 395.6,211.54 395.6,211.01 395.93,210.45 396.4,210.18 396.72,210.37  396.72,210.9 396.4,211.46  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "398.62,208.13 398.48,208.05 397.9,208.39 398.05,208.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "398.04,208.47 397.9,208.39 397.49,209.09 397.64,209.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "397.64,209.18 397.49,209.09 397.49,209.75 397.64,209.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "398.04,210.07 397.64,209.83 397.64,209.18 398.04,208.47 398.62,208.13  399.03,208.37 399.03,209.04 398.62,209.74  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "399.09,208.63 398.59,208.34 398.14,208.62 398.62,209.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "398.62,208.9 398.14,208.62 397.81,209.18 398.3,209.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "398.3,209.46 397.81,209.18 397.81,209.71 398.3,209.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "398.62,210.18 398.3,209.99 398.3,209.46 398.62,208.9 399.09,208.63 399.41,208.82  399.41,209.35 399.09,209.92  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "289.31,62.07 289.31,63.11 292.53,64.97 293.68,63.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "292.53,63.93 292.53,64.97 297.1,64.97 300.32,62.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "297.1,63.93 297.1,64.97 300.32,63.11 300.32,62.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "300.32,59.43 300.32,62.07 297.1,63.93 292.53,63.93 289.31,62.07 289.31,59.43  292.53,57.57 297.1,57.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "292.88,43.77 293.44,44.98 292.88,63.17 290.15,61.6 290.15,38.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "296.75,38.35 297.79,44.65 296.75,63.17 292.88,63.17 292.88,40.57 295.76,40.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "296.75,38.35 296.75,63.17 299.48,61.6 299.48,38.99 297.13,37.09  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "335.66,100.11 335.66,101.15 338.89,103.01 340.02,101.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "338.89,101.97 338.89,103.01 343.45,103.01 346.67,100.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "343.45,101.97 343.45,103.01 346.67,101.16 346.67,100.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "346.67,97.47 346.67,100.11 343.45,101.97 338.89,101.97 335.66,100.11 335.66,97.47  338.88,95.61 343.45,95.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "339.23,67.31 339.79,71.72 339.23,101.22 336.5,99.65 336.5,68.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "343.09,65.09 344.15,71.39 343.09,101.22 339.23,101.22 339.23,67.31 339.6,65.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "343.09,65.09 343.09,101.22 345.83,99.65 345.83,63.52 343.48,63.84  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "345.83,63.52 295.62,34.53 292.88,36.1 299.85,41.97 328.39,57.86 343.09,65.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "343.09,65.09 292.88,36.1 290.15,38.99 310.11,52.62 339.23,67.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "339.23,67.31 290.15,38.99 292.88,43.77 336.5,68.89 337.83,69.82  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "272.86,71.56 272.86,72.6 276.1,74.46 277.23,72.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "276.1,73.42 276.1,74.46 280.66,74.46 283.88,71.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "280.66,73.42 280.66,74.46 283.88,72.6 283.88,71.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "283.88,68.92 283.88,71.56 280.66,73.42 276.1,73.42 272.86,71.56 272.86,68.92  276.09,67.06 280.66,67.06  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "276.44,53.27 277,54.47 276.44,72.67 273.7,71.09 273.7,48.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "280.3,47.84 281.35,54.14 280.3,72.67 276.44,72.67 276.44,50.06 279.31,50.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "280.3,47.84 280.3,72.67 283.04,71.09 283.04,48.49 280.69,46.59  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "319.22,109.6 319.22,110.64 322.44,112.51 323.58,110.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "322.44,111.46 322.44,112.51 327.01,112.51 330.23,109.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "327.01,111.46 327.01,112.51 330.23,110.65 330.23,109.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "330.23,106.97 330.23,109.6 327.01,111.46 322.44,111.46 319.22,109.6 319.22,106.97  322.44,105.11 327.01,105.11  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "322.79,76.81 323.34,81.21 322.79,110.71 320.05,109.13 320.05,78.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "326.65,74.58 327.7,80.88 326.65,110.71 322.79,110.71 322.79,76.81 323.16,74.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "326.65,74.58 326.65,110.71 329.39,109.13 329.39,73.01 327.03,73.33  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "329.39,73.01 279.18,44.02 276.44,45.59 283.41,51.46 311.94,67.35 326.65,74.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "326.65,74.58 276.44,45.59 273.7,48.49 293.67,62.11 322.79,76.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "322.79,76.81 273.7,48.49 276.44,53.27 320.05,78.38 321.39,79.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#785B56"
    },
    points: "304.5,179.24 310.13,181.96 313.11,187 314.87,190.68 314.85,196.55 311.25,199.73  303.88,195.94 299.68,187.7 299.79,181.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "309.24,198.36 304.2,195.41 306.91,193.96 312.56,197.18 310.19,198.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "302.55,192.87 300.7,188.58 303.29,187.05 306.91,193.96 304.62,195.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "300.7,188.58 299.79,180.9 303.25,178.99 303.29,187.05  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#211A1A"
    },
    points: "310.97,197.94 311.97,197.36 306.46,194.22 302.54,187.51 302.5,181.17 301.49,181.75  301.54,188.09 305.45,194.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#736656"
    },
    points: "314.85,196.82 310.97,197.94 305.45,194.8 301.54,188.09 301.49,181.75  304.49,179 310.88,182.62 314.8,189.34  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#685750"
    },
    d: "M310.77,181.48l-6.98-3.98l-4.92,2.86l0.05,8.05l4.97,8.51l6.99,3.99l4.93-2.87l-0.04-8.06 L310.77,181.48z M313.99,196.16l-3.87,2.26l-5.5-3.15l-3.92-6.7l-0.04-6.33l3.87-2.27l5.51,3.13l3.91,6.72L313.99,196.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "310.77,181.48 303.79,177.5 306.39,175.96 313.37,179.95 311.73,181.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "315.76,189.98 310.77,181.48 313.37,179.95 318.36,188.48 316.66,190.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "315.8,198.04 315.76,189.98 318.36,188.48 318.39,196.52  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "409.26,404.81 400.85,400.14 388.95,400.14 380.53,404.81 380.53,411.41 388.95,416.08  400.85,416.08 409.26,411.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#418080"
    },
    points: "391.04,403.5 388.14,403.8 385.84,403.17 382.9,403.95 382.9,404.44 382.98,405.87  386.54,406.69 392.69,406.07 393.45,406.26 396.89,406.56 399.83,406 399.83,405.51 397.15,402.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "391.71,400.34 389.58,401.58 385.69,402.41 383.37,402.59 382.9,403.95 382.98,405.38  386.54,406.21 392.69,405.58 393.45,405.77 396.89,406.08 399.83,405.51 399.83,403.22 398.97,400.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#418080"
    },
    points: "400.85,405.52 398.04,408.83 394.46,412.68 394.46,413.17 395.72,414.73 399.62,414.56  402.67,412.08 405.55,408.92 407.18,407.58 407.52,405.39 407.52,404.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "400.85,405.04 398.04,408.35 394.66,411.08 394.46,412.68 395.72,414.24 399.62,414.07  402.67,411.6 405.55,408.43 407.18,407.09 407.52,404.91 407.18,402.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "364.33,307.13 365.7,307.79 367.41,307.6 368.16,305.46 367.71,304.45 366.35,304.01  364.33,305.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "366.35,304.01 364.32,300.14 362.27,298.8 358.59,298.97 358.59,299.63 358.96,300.05  359.79,302.35 361.75,303.72 363.28,306.59 364.33,307.13 365.56,306.79 366.65,305.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "392.43,351.99 389.93,363.83 388.39,375.99 390.22,384.18 390.95,400.25 392.95,402.59  397.97,402.37 399.62,399.47 399.09,382.81 396.83,377.77 398.32,372.44 398.14,352.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "397.59,375.03 398.92,369.88 397.59,355.71 392.43,351.99 393.96,356.8 395.67,360.13  395.89,371.35 397.06,376.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "394.46,356.19 396.56,359.21 396.67,370.62 399.44,383.96 400.42,387.69 400.38,405.19  402.74,407.09 406.29,405.79 407.93,402.93 408.8,386.47 407.15,381.19 410.23,360.48 410.23,353.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "365.7,307.79 367.23,306.46 367.71,304.45 369.47,305.16 371.76,304.51 383.59,311.01  393.01,312.64 398.4,312.05 400.12,315.11 397.67,320.19 381.6,316.69 368.99,310.88 368.13,308.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "394.2,319.44 397.38,317.62 396.85,319.23 395.22,319.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C7A495"
    },
    points: "398.06,314.76 398.21,315.43 399.44,316.08 402.02,315.57 403.15,313.5 402.11,312.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "398.63,316.43 398.21,315.43 400.94,314.76 403.8,312.64 405.52,312.93 405.78,316.24  405.32,319.33 401.3,321.73 398.63,321.57 397.14,319.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "392.43,351.99 394.46,356.19 398.62,359.22 402.39,359.44 406.12,359.05 408.33,357.23  410.23,353.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "405.38,315.34 404.82,318.27 401.22,320.5 398.63,320.84 399.05,317.21 398.63,316.43  395.22,319.67 393.96,321.93 391.3,324.23 389.83,325.82 389.18,327.95 389.53,330.76 391.82,333.37 392.64,342.85  392.43,351.99 395.05,355.76 398.75,358.23 402.35,358.44 405.68,358.06 408.06,356.63 410.23,353.72 408.41,349.3 407.2,345.88  408.28,339.91 411.05,331.33 410.79,326.43 408.76,320.5 406.46,316.77 406.07,314.17 404.99,314.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "391.82,333.37 395.05,338.99 394.25,339.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "392.43,340.33 401.64,329.76 408.33,334.06 396.41,349.3 392.48,349.74 392.5,348.87  393.16,343.5 392.51,341.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#97C5CF"
    },
    points: "374.91,328.68 375.47,328.59 377.4,333.22 376.16,333.43 374.91,330.67  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "373.45,323.33 377.4,333.88 378.55,333.43 374.25,322.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "382.6,340.27 381.84,339.7 380.53,338.62 380.26,338.35 376.74,330.03 379.33,331.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "377.73,327.67 378.08,332.8 378.03,333.37 372.19,318.27 373.45,318.58  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "373.97,323.59 373.85,324.23 373.28,323.86 370,315.38 370.69,315.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "381.18,342.24 380.49,342.5 373.28,323.86 373.97,323.59  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "377.8,327.67 376.89,326.73 374.71,324.32 374.06,323.5 373.97,323.59 370.69,315.11  370.78,315.03 374.53,319.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "382.51,340.33 380.25,338.46 378.03,333.37 377.68,327.72 373.97,323.59 374.06,323.5  377.8,327.67 377.81,327.69 378.16,333.35 380.36,338.39 382.59,340.23  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "378.88,339.24 380.02,340.16 381.83,337.33 380.21,336.48 379.46,335.86 378.44,336.43  378.08,338.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "394.38,304.81 394.15,306.85 393.01,308.02 393.99,309.19 393.95,313.46 395.94,314.76  399.28,314.76 402.02,312.83 404.25,307.54 394.44,302.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "396.85,314.27 400.55,310.38 400.78,310.54 397.37,314.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "396.72,309.73 395.13,308.61 393.97,306.85 392.77,308.02 393.45,309.73 393.77,313.33  395.76,314.48 397.37,314.48 396.54,313.63 396.69,310.66 397.67,309.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#362C29"
    },
    points: "393.84,304.4 394.88,303.56 394.81,306.24 395.76,307.72 395.76,306.81 396.06,306.31  396.37,308.15 397.67,310.97 397.84,310.53 399.23,312.01 399.23,313.35 401.09,312.61 401.91,312.92 402.3,313.45  402.38,314.31 401.73,314.63 404.33,315.04 406.25,314.36 407.55,313.71 409.28,310.88 410.27,307.5 410.27,304.51  409.75,301.92 407.59,299.62 405.16,298.27 402.82,297.62 400.18,297.62 397.84,298.67 395.28,300.14 393.99,302.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "374.25,328.01 374.25,330.47 374.72,334.44 378.88,339.24 378.42,337.81 379.2,336.55  380.21,336.48 380.05,334.27 379.36,332.32 379.43,330.03 379.01,329.27 378.28,329.21 378.08,330.54 377.91,333.04  376.74,332.81 375.86,331.48 375.14,328.67 374.79,327.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "380.04,340.27 379.86,338.86 380.69,337.52 381.94,337.3 383.29,338.08 384.71,337.65  392.86,341.55 401.48,330.03 403.55,326.52 407.03,325.61 409.32,326.82 410.23,329.38 409.84,331.92 408.33,334.06  395.94,348.57 391.56,348.87 381.99,342.93 381.51,341.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "383.29,338.08 381.97,339.04 381.97,340.68 382.59,339.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "392.86,341.55 395.05,344.83 393.76,344.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#7DD2E3"
    },
    points: "393.42,304.34 394.55,306.46 395.85,308.07 397.67,309.62 399.4,311.4  400.61,312.8 401.46,314.97 404.45,315.46 407.31,314.48 408.83,312.86 409.87,310.85 410.45,308.74 410.84,306.85  410.66,304.69 409.97,301.74 407.85,299.19 405.51,297.62 402.78,296.98 400.12,297.15 397.37,298.27 395.05,299.58  393.42,301.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "382.74,311.46 381.18,315.11 382.45,314.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "369.41,305.52 368.95,307.31 368.16,308.42 369.52,307.57  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "362.74,302.73 362.74,310.41 361.16,311.31 360.61,303.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "361.16,303.64 361.16,311.31 358.94,311.31 357.37,302.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "358.94,303.64 358.94,311.31 357.37,310.41 357.37,307.87 358.14,306.96 357.37,304.68  357.37,302.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "360.91,302.61 359.19,302.61 358.94,303.64 361.16,303.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "362.13,301.91 360.91,302.61 361.16,303.64 362.74,302.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "362.13,300.91 362.13,301.91 362.74,302.73 362.74,301.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "359.19,302.61 357.97,301.91 357.37,302.73 358.94,303.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "357.97,301.91 357.97,300.91 357.37,301.45 357.37,302.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "360.91,300.21 359.19,300.21 357.97,300.91 357.97,301.91 359.19,302.61 360.91,302.61  362.13,301.91 362.13,300.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "362.36,301.47 362.36,302.06 361.01,302.84 360.53,301.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "361.01,302.25 361.01,302.84 359.09,302.84 357.74,301.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "359.09,302.25 359.09,302.84 357.74,302.06 357.74,301.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "357.74,300.36 357.74,301.47 359.1,302.25 361.01,302.25 362.36,301.47 362.36,300.36  361.01,299.58 359.1,299.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "361.75,299.23 361.75,301.25 360.76,301.82 360.4,299.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "360.75,299.81 360.76,301.82 359.35,301.82 358.35,299.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "359.35,299.81 359.35,301.82 358.35,301.25 358.35,299.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "358.35,298.41 358.35,299.23 359.35,299.81 360.76,299.81 361.76,299.23 361.76,298.41  360.76,297.84 359.35,297.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "357.37,304.68 357.37,307.87 358.94,308.78 358.94,305.59  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.94,
    y: 305.59,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "361.95,305.14 361.95,308.32 361.17,308.78 361.17,305.59  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "364.62,302.61 363.25,301.98 361.92,301.78 360.8,301.43 360.43,302.04 360.8,302.61  362.13,303.31 363.45,305.16 364.62,306.01 366.29,304.59  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "300.99,354.19 311.04,349.7 325.24,349.7 335.28,354.19 335.28,360.54 325.24,365.04  311.03,365.04 300.99,360.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "311.75,253.73 307.28,253.89 301.74,256.39 294.33,258.28 290,259.06 288,259.06  285.97,261.25 285.97,263.54 288.7,266.44 292.18,265.68 304.03,264.61 308.34,265.03 311.96,262.19 314.16,255.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "309.36,258.28 305.37,263.86 306.89,264.89 309.1,263.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "292.6,263.23 292.18,265.29 293.55,262.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#418080"
    },
    points: "311.72,351.03 309.22,352.92 303.7,355.74 303.21,358.7 303.21,359.38 306.24,359.73  309.93,358.67 312.66,356.52 319.2,355.74 320.35,354.31 320.35,353.63 319.45,350.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#418080"
    },
    points: "325.46,353.37 323.53,356.87 319.74,363.19 319.74,363.87 322.67,364.58 326.63,363.64  329.78,360.32 330.66,358.98 332.97,356.55 332.97,355.87 332.55,352.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "311.72,350.35 309.22,352.23 303.7,355.06 303.24,356.68 303.21,358.7 306.24,359.05  309.93,357.99 312.66,355.84 319.2,355.06 320.35,353.63 320.17,351.1 319.45,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "325.46,352.69 323.53,356.19 319.91,360.68 319.74,363.19 322.67,363.9 326.63,362.96  329.78,359.64 330.66,358.29 332.97,355.87 332.97,353.21 332.55,352.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "320.17,309.3 317.42,325.83 319.06,332.18 320.35,349.7 317.78,351.56 313.39,351.67  310.87,350.11 307.44,325 306.24,305.49 306.81,297.82 310.05,296.57 320.54,301.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "319.2,315.15 318.37,313.81 316.33,306.45 310.79,300.82 318.98,303.37 321.66,310.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "331.52,302.92 331.54,324.75 333.53,331.4 333.88,352.23 330.89,354.19 327.32,354.19  324.78,352.62 323.48,328.97 318.7,313.55 317.33,305.92 306.81,297.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C7A495"
    },
    points: "324.31,253.18 324.31,254.01 323.89,256.63 321.62,259.44 317.52,260.13 315.73,258.74  315.96,255.42 317.38,251.72 322.85,251.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "324.69,256.26 324.39,255.51 324.39,253.89 322.73,256.82 319.39,258.84 316.43,258.74  315.03,256.33 314.16,260.61 316.17,263.56 319.42,263.6 323.61,262.19 325.11,259.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "330.59,304.45 328.38,306.49 323.91,306.76 318.42,305.92 311.09,303.03 306.81,297.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "315.25,259.67 315.96,262.19 319.66,262.53 323.13,260.59 324.69,256.26 327.38,259.55  329.89,262.19 332.71,263.54 331.62,270.71 329.55,279.85 329.02,288.68 331.37,295.01 331.8,302.46 330.59,304.45  328.51,305.92 324.18,305.92 318.74,305.23 311.48,302.37 306.24,297.26 306.24,276.82 304.77,270.09 307.71,262.43  309.36,258.28 312.29,255.28 314.16,255.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "329.47,281.2 326.47,284.92 323.03,284.92 319.66,283.94 309.88,274.45 309.51,272.57  308.34,270.42 311.68,267.01 313.54,267.85 316.21,267.81 322.28,272.98 326.73,267.29 329.78,273.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#97C5CF"
    },
    points: "295.2,260.03 295.04,261.25 294.02,262.43 293.12,263.73 291.49,263.97 291.23,259.55  294.41,259.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "311.68,267.01 309.97,265.68 307.84,267.29 307.28,268.84 307.44,270 308.34,270.42  309.68,271.12 312.11,270.34 312.48,268.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "311.96,244.3 310.75,248.09 311.07,248.98 310.96,251.47 311.66,258.38 313.84,259.75  316.55,259.6 321.53,256.67 321.94,254.55 323.18,254.05 323.98,253.24 324.61,252.6 325.17,251.3 325.26,248.98 322.62,245.02  314.95,243.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#574943"
    },
    points: "323.98,253.24 324.91,251.48 324.65,249.83 323.55,249.44 321.89,250.96 321.31,249.44  319.58,248.46 318.87,246.84 314.36,246.25 315.96,247.52 313.8,246.97 312.69,245.25 312.31,245.8 311.75,243.4 313.93,241.18  316.76,239.5 320.01,239.27 323.03,240.24 325.17,242.39 326.15,245.31 326.15,248.63 325.69,250.64 325.16,252.21  324.47,253.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "334.98,265.16 332.71,263.54 329,264.71 326.93,266.98 322.38,274.13 315.96,268.35  313.48,268.48 311.68,267.01 311.4,268.19 309.77,269.97 308.34,270.42 310.03,271.99 310.16,274.13 320.43,283.23 323.16,284.2  326.41,284.2 329.78,280.89 335.08,272.4 336.22,268.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "306.89,263.86 305.21,262.4 303.37,261.94 301.03,261.89 301.15,262.96 303.04,263.4  304.29,264.37 305.85,265.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "295.11,260.91 295.76,261.14 296.49,260.35 296.49,258.61 294.84,257.53 293.9,257.67  289.89,259.34  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "302.75,267.08 302.75,274.75 301.18,275.66 300.62,267.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "301.18,267.99 301.18,275.66 298.95,275.66 297.38,267.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "298.95,267.99 298.95,275.66 297.38,274.75 297.38,272.21 298.16,271.3 297.38,269.03  297.38,267.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "300.93,266.96 299.2,266.96 298.95,267.99 301.18,267.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "302.14,266.25 300.93,266.96 301.18,267.99 302.75,267.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "302.14,265.25 302.14,266.25 302.75,267.08 302.75,265.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "299.2,266.96 297.98,266.25 297.38,267.08 298.95,267.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "297.98,266.25 297.98,265.25 297.38,265.79 297.38,267.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "300.93,264.55 299.2,264.55 297.98,265.25 297.98,266.25 299.2,266.96 300.93,266.96  302.14,266.25 302.14,265.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "302.38,265.81 302.38,266.4 301.02,267.18 300.54,266.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "301.02,266.59 301.02,267.18 299.11,267.18 297.75,265.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "299.11,266.59 299.11,267.18 297.75,266.4 297.75,265.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "297.75,264.71 297.75,265.81 299.11,266.59 301.02,266.59 302.38,265.81 302.38,264.71  301.02,263.92 299.11,263.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "301.77,263.58 301.77,265.59 300.77,266.17 300.42,263.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "300.76,264.15 300.77,266.17 299.36,266.17 298.37,263.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "299.36,264.15 299.36,266.17 298.36,265.59 298.37,263.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "298.36,262.76 298.37,263.58 299.36,264.15 300.77,264.16 301.77,263.58 301.77,262.76  300.77,262.19 299.36,262.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "297.38,269.03 297.38,272.21 298.95,273.12 298.95,269.94  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.95,
    y: 269.94,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "301.96,269.49 301.96,272.67 301.18,273.12 301.18,269.94  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "309.97,265.68 306.89,263.86 304.03,264.99 301.69,264.8 298.23,264.08 297.41,264.08  297.41,264.95 299.96,266.12 302.08,266.81 303.3,270.71 307.29,270.1 308.75,269.19 309.97,266.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "302.08,266.81 301.29,267.47 299.82,267.08 298.68,267.23 298.95,269.94 300.77,271.12  303.3,270.71 304.31,267.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "322.38,274.13 325.99,278.42 323.87,277.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "313.48,268.48 312.92,270.3 311.04,271.7 313.54,270.49  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "295.8,263.84 295.8,271.51 294.23,272.42 293.67,264.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "294.23,264.75 294.23,272.42 292.01,272.42 290.44,263.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "292.01,264.75 292.01,272.42 290.43,271.51 290.43,268.97 291.21,268.07 290.44,265.79  290.44,263.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "293.98,263.72 292.26,263.72 292.01,264.75 294.23,264.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "295.2,263.01 293.98,263.72 294.23,264.75 295.8,263.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "295.2,262.02 295.2,263.01 295.8,263.84 295.81,262.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "292.26,263.72 291.04,263.01 290.44,263.84 292.01,264.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "291.04,263.01 291.03,262.02 290.43,262.55 290.44,263.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "293.98,261.32 292.26,261.32 291.03,262.02 291.04,263.01 292.26,263.72 293.98,263.72  295.2,263.01 295.2,262.02  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "295.43,262.57 295.43,263.16 294.08,263.94 293.6,263.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "294.07,263.35 294.08,263.94 292.16,263.94 290.81,262.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "292.16,263.35 292.16,263.94 290.81,263.16 290.81,262.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "290.81,261.46 290.81,262.57 292.17,263.35 294.08,263.35 295.43,262.57 295.43,261.46  294.08,260.68 292.17,260.68  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "294.82,260.34 294.82,262.35 293.82,262.93 293.47,260.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "293.82,260.92 293.82,262.93 292.41,262.93 291.42,260.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "292.41,260.92 292.41,262.93 291.41,262.35 291.42,260.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "291.41,259.52 291.42,260.34 292.41,260.92 293.82,260.92 294.82,260.34 294.82,259.52  293.82,258.95 292.41,258.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "290.43,265.79 290.43,268.97 292.01,269.88 292.01,266.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.01,
    y: 266.7,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "295.02,266.25 295.02,269.43 294.23,269.88 294.23,266.7  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "292.18,259.99 292.31,261.7 292.08,263.75 290.76,264.25 289.65,264.02 288.97,262.17  288.92,259.34 289.63,257.83 293.9,257.67 294.74,258.95 292.41,258.95 291.6,259.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "288.92,259.34 288.28,260.73 288.28,261.76 289.28,262.53 290.1,263.15 290.28,261.18  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "317.15,253.55 322.62,250.29 321.89,250.96 316.94,254.17 316.7,253.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "320.54,251.72 317.36,258.84 317.02,258.84 317.02,258.5 319.9,252.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "317.52,253.58 315.66,253.43 312.41,252.39 310.8,250.51 310.8,253.07 311.37,257.99  313.95,259.55 316.27,259.25 317.36,258.84 316.54,258.03 316.57,254.53  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#7DD2E3"
    },
    points: "323.18,254.05 321.83,251.72 320.21,250.51 318,249.01 315.88,248.14  313.54,247.4 311.75,245.93 311.48,244.15 311.48,242.64 313.54,240.73 315.68,239.27 317.02,238.61 320.06,238.82  323.18,239.56 325.26,241.12 326.51,244.54 326.9,248.14 326.51,250.87 325.26,252.99 324.39,254.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "175.35,137.47 175.35,280.29 122.96,310.57 122.96,167.75 123.13,166.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "122.96,167.75 122.96,310.57 59.14,273.72 59.14,130.9 116.49,163.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "175.35,137.47 111.53,100.62 59.14,130.9 122.96,167.75  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "112.05,219.05 109.46,220.55 67.46,154.49 112.05,177.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "109.46,178.76 67.46,154.49 70.05,152.99 112.05,177.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "109.46,220.55 67.46,196.29 67.46,154.49 109.46,178.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "69.41,159.39 69.41,191.54 78.57,196.83 78.57,196.11 70.05,191.17 70.05,159.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#736656"
    },
    points: "70.05,159.76 70.05,191.17 78.57,196.11 78.57,164.71  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "77.44,165.42 77.44,168.08 72.2,165.05 72.2,162.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3D791"
    },
    points: "77.44,173.28 72.2,170.25 72.2,167.59 77.44,170.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8CCCCB"
    },
    points: "77.44,178.48 72.2,175.45 72.2,172.79 77.44,175.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB9D67"
    },
    points: "77.44,183.68 72.2,180.65 72.2,177.98 77.44,181.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D18067"
    },
    points: "77.44,188.87 72.2,185.84 72.2,183.18 77.44,186.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "77.44,194.07 72.2,191.05 72.2,188.38 77.44,191.41  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "104.83,214.67 102.86,215.82 79.51,166.45 104.83,178.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "102.86,179.94 79.51,166.45 81.48,165.31 104.83,178.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "102.86,215.82 79.51,202.34 79.51,166.45 102.86,179.94  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E4439"
    },
    points: "82.1,170.59 82.1,179.34 100.37,189.88 100.37,189.16 82.74,178.98 82.74,170.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#736656"
    },
    points: "82.74,170.96 82.74,178.98 100.37,189.16 100.37,181.15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#574943"
    },
    points: "82.1,182.02 82.1,194.71 100.37,205.25 100.37,204.52 82.74,194.35 82.74,182.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#362C29"
    },
    points: "82.74,182.39 82.74,194.35 100.37,204.52 100.37,192.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "85,190.76 85.31,190.59 86.53,191.29 86.22,191.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "86.23,191.47 86.53,191.29 87.4,192.79 87.09,194.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "87.09,192.97 87.4,192.79 87.4,194.2 87.09,194.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "86.23,194.88 87.09,194.38 87.09,192.97 86.23,191.47 85,190.76 84.13,191.27  84.13,192.68 85,194.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "84.02,191.82 85.05,191.21 86.03,191.78 84.98,192.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "85,192.39 86.03,191.78 86.73,192.98 85.69,194.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "85.69,193.58 86.73,192.98 86.73,194.11 85.69,194.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "85,195.1 85.69,194.71 85.69,193.58 85,192.39 84.02,191.82 83.33,192.2  83.33,193.35 84.02,194.54  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "90.71,194.07 91.02,193.89 92.24,194.59 91.93,195.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "91.94,194.78 92.24,194.59 93.11,196.1 92.8,197.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "92.8,196.28 93.11,196.1 93.11,197.51 92.8,197.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "91.94,198.19 92.8,197.68 92.8,196.28 91.94,194.77 90.71,194.07 89.84,194.57  89.84,195.98 90.71,197.48  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "89.73,195.12 90.76,194.51 91.74,195.09 90.7,196.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "90.71,195.69 91.74,195.09 92.44,196.29 91.4,198.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "91.4,196.88 92.44,196.29 92.44,197.42 91.4,198.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "90.71,198.41 91.4,198.01 91.4,196.88 90.71,195.69 89.73,195.12 89.04,195.51  89.04,196.66 89.73,197.85  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "90.71,188.87 91.02,188.69 92.24,189.39 91.93,190.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "91.94,189.58 92.24,189.39 93.11,190.9 92.8,192.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "92.8,191.08 93.11,190.9 93.11,192.31 92.8,192.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "91.94,192.99 92.8,192.48 92.8,191.08 91.94,189.58 90.71,188.87 89.84,189.37  89.84,190.78 90.71,192.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "89.73,189.92 90.76,189.32 91.74,189.89 90.7,190.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "90.71,190.5 91.74,189.89 92.44,191.09 91.4,192.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "91.4,191.69 92.44,191.09 92.44,192.22 91.4,192.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "90.71,193.21 91.4,192.82 91.4,191.69 90.71,190.5 89.73,189.92 89.04,190.31  89.04,191.46 89.73,192.65  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "85,185.57 85.31,185.39 86.53,186.09 86.22,186.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "86.23,186.28 86.53,186.09 87.4,187.6 87.09,189.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "87.09,187.78 87.4,187.6 87.4,189.01 87.09,189.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "86.23,189.68 87.09,189.18 87.09,187.78 86.23,186.27 85,185.57 84.13,186.07  84.13,187.48 85,188.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBE979"
    },
    points: "84.02,186.62 85.05,186.01 86.03,186.58 84.98,187.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6A950"
    },
    points: "85,187.19 86.03,186.58 86.73,187.79 85.69,189.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC934C"
    },
    points: "85.69,188.38 86.73,187.79 86.73,188.91 85.69,189.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3BD5E"
    },
    points: "85,189.91 85.69,189.51 85.69,188.38 85,187.19 84.02,186.62 83.33,187.01  83.33,188.15 84.02,189.35  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "96.41,197.36 96.72,197.19 97.94,197.89 97.63,198.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "97.64,198.07 97.94,197.89 98.81,199.4 98.51,200.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "98.51,199.57 98.81,199.4 98.81,200.8 98.51,200.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "97.64,201.48 98.51,200.98 98.51,199.57 97.64,198.07 96.41,197.36 95.55,197.86  95.55,199.28 96.41,200.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FA5C52"
    },
    points: "95.43,198.41 96.46,197.81 97.45,198.38 96.4,199.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB281F"
    },
    points: "96.41,198.99 97.45,198.38 98.15,199.58 97.1,201.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A1C14"
    },
    points: "97.1,200.18 98.15,199.58 98.15,200.71 97.1,201.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C84030"
    },
    points: "96.41,201.7 97.1,201.31 97.1,200.18 96.41,198.99 95.43,198.41 94.74,198.8  94.74,199.95 95.43,201.15  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "96.41,192.16 96.72,191.98 97.94,192.68 97.63,193.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "97.64,192.87 97.94,192.68 98.81,194.19 98.51,195.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "98.51,194.37 98.81,194.19 98.81,195.6 98.51,195.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "97.64,196.28 98.51,195.77 98.51,194.37 97.64,192.87 96.41,192.16 95.55,192.66  95.55,194.07 96.41,195.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FA5C52"
    },
    points: "95.43,193.21 96.46,192.61 97.45,193.18 96.4,194.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB281F"
    },
    points: "96.41,193.78 97.45,193.18 98.15,194.38 97.1,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A1C14"
    },
    points: "97.1,194.98 98.15,194.38 98.15,195.51 97.1,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C84030"
    },
    points: "96.41,196.5 97.1,196.1 97.1,194.98 96.41,193.78 95.43,193.21 94.74,193.6  94.74,194.75 95.43,195.94  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "131.36,307.89 171.29,284.83 171.37,284.79 227.79,284.79 267.64,307.79 267.8,307.89  267.8,340.74 262.22,343.95 256.3,340.53 259.7,338.58 259.7,310.05 224.53,289.74 174.63,289.74 139.46,310.05 139.46,338.58  174.63,358.89 224.53,358.89 227.77,357.06 233.65,360.46 232.49,361.13 239.59,365.23 270.4,347.44 396.59,420.21 365.78,438  347.13,427.24 344.39,428.82 229.75,362.71 227.79,363.84 171.37,363.84 131.52,340.83 131.36,340.74  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "139.13,269.85 174.54,249.41 174.54,258.85 139.13,279.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.54,
    y: 249.41,
    style: {
      fill: "#B5AFA7"
    },
    width: 50.08,
    height: 9.45
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "224.62,249.41 260.02,269.85 260.02,279.3 224.62,258.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "231.07,333.02 258.37,317.26 258.37,307.88 231.07,323.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "139.13,308.21 139.13,279.3 174.54,258.85 224.62,258.85 260.02,279.3 260.02,308.21  224.62,328.65 174.54,328.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "190.96,295.81 190.96,291.69 196.01,288.78 203.15,288.78 208.19,291.69 208.19,295.81  203.15,298.73 196.01,298.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "233,320.45 233,360.46 227.7,363.52 227.7,323.51 226.94,322.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "267.5,300.53 267.5,340.54 262.21,343.59 262.21,303.58 261.44,302.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "262.21,303.58 262.21,343.59 256.95,340.54 256.95,300.53 262.21,300.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "227.7,323.51 227.7,363.52 171.45,363.52 171.45,323.51 196.44,321.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "171.45,323.51 171.45,363.52 131.68,340.55 131.68,300.54 159.02,312.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "131.68,268.07 171.46,245.11 227.7,245.11 267.48,268.07 267.47,300.54 262.22,303.57  256.95,300.53 260.02,298.76 260.02,269.85 224.62,249.41 174.54,249.41 139.13,269.85 139.13,298.76 174.54,319.21  224.62,319.21 227.77,317.43 233,320.45 227.7,323.51 171.45,323.51 131.68,300.54  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "221.93,256.24 221.93,263.92 223.51,264.82 224.06,256.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "223.51,257.15 223.51,264.82 225.73,264.82 227.3,256.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "225.73,257.15 225.73,264.82 227.3,263.92 227.3,261.38 226.53,260.47 227.3,258.2  227.3,256.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "223.76,256.12 225.48,256.12 225.73,257.15 223.51,257.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "222.53,255.42 223.76,256.12 223.51,257.15 221.93,256.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "222.53,254.42 222.53,255.42 221.93,256.24 221.93,254.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "225.48,256.12 226.7,255.42 227.3,256.25 225.73,257.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "226.7,255.42 226.7,254.42 227.3,254.96 227.3,256.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "223.76,253.72 225.48,253.72 226.7,254.42 226.7,255.42 225.48,256.12  223.76,256.12 222.53,255.42 222.53,254.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "222.31,254.98 222.31,255.57 223.66,256.34 224.14,255.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "223.66,255.76 223.66,256.34 225.58,256.34 226.93,254.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "225.58,255.76 225.58,256.34 226.93,255.57 226.93,254.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "226.93,253.87 226.93,254.98 225.57,255.76 223.66,255.76 222.31,254.98  222.31,253.87 223.66,253.09 225.57,253.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "222.91,252.74 222.91,254.76 223.91,255.33 224.26,253.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "223.91,253.32 223.91,255.33 225.32,255.33 226.32,252.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "225.32,253.32 225.32,255.33 226.32,254.76 226.32,252.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "226.32,251.92 226.32,252.74 225.32,253.32 223.91,253.32 222.91,252.74  222.91,251.92 223.91,251.35 225.32,251.35  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "227.3,258.2 227.3,261.38 225.72,262.28 225.72,259.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 259.1,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "222.71,258.65 222.71,261.83 223.5,262.28 223.5,259.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "212.66,256.35 212.66,264.02 214.23,264.93 214.79,256.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "214.23,257.25 214.23,264.93 216.46,264.93 218.03,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "216.46,257.25 216.46,264.93 218.03,264.02 218.03,261.48 217.25,260.57  218.03,258.3 218.03,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "214.48,256.23 216.21,256.23 216.46,257.25 214.23,257.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "213.26,255.52 214.48,256.23 214.23,257.25 212.66,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "213.26,254.53 213.26,255.52 212.66,256.35 212.66,255.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "216.21,256.23 217.43,255.52 218.03,256.35 216.46,257.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "217.43,255.52 217.43,254.53 218.03,255.06 218.03,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "214.48,253.83 216.21,253.83 217.43,254.53 217.43,255.52 216.21,256.23  214.48,256.23 213.26,255.52 213.26,254.53  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "213.03,255.08 213.03,255.67 214.39,256.45 214.87,255.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "214.39,255.86 214.39,256.45 216.3,256.45 217.66,255.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "216.3,255.86 216.3,256.45 217.66,255.67 217.66,255.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "217.66,253.98 217.66,255.08 216.3,255.86 214.39,255.86 213.03,255.08  213.03,253.98 214.39,253.19 216.3,253.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "213.64,252.84 213.64,254.86 214.64,255.44 214.99,253.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "214.64,253.42 214.64,255.44 216.05,255.44 217.05,252.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "216.05,253.42 216.05,255.44 217.05,254.86 217.05,252.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "217.05,252.03 217.05,252.84 216.05,253.42 214.64,253.42 213.64,252.84  213.64,252.03 214.64,251.45 216.05,251.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "218.03,258.3 218.03,261.48 216.46,262.39 216.45,259.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "216.45,259.2 216.46,262.39 214.23,262.39 214.23,259.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "213.44,258.75 213.44,261.93 214.23,262.39 214.23,259.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "202.98,256.35 202.98,264.02 204.56,264.93 205.11,256.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "204.56,257.25 204.56,264.93 206.78,264.93 208.35,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "206.78,257.25 206.78,264.93 208.36,264.02 208.36,261.48 207.58,260.57  208.35,258.3 208.35,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "204.81,256.23 206.53,256.23 206.78,257.25 204.56,257.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "203.58,255.52 204.81,256.23 204.56,257.25 202.98,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "203.58,254.53 203.58,255.52 202.98,256.35 202.98,255.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "206.53,256.23 207.75,255.52 208.35,256.35 206.78,257.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "207.75,255.52 207.75,254.53 208.36,255.06 208.35,256.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "204.81,253.83 206.53,253.83 207.75,254.53 207.75,255.52 206.53,256.23  204.81,256.23 203.58,255.52 203.58,254.53  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "203.36,255.08 203.36,255.67 204.71,256.45 205.19,255.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "204.71,255.86 204.71,256.45 206.63,256.45 207.98,255.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "206.63,255.86 206.63,256.45 207.98,255.67 207.98,255.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "207.98,253.98 207.98,255.08 206.62,255.86 204.71,255.86 203.36,255.08  203.36,253.98 204.71,253.19 206.62,253.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "203.97,252.84 203.97,254.86 204.96,255.44 205.31,253.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "204.96,253.42 204.96,255.44 206.37,255.44 207.37,252.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "206.37,253.42 206.37,255.44 207.38,254.86 207.37,252.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "207.38,252.03 207.37,252.84 206.37,253.42 204.96,253.42 203.97,252.84  203.97,252.03 204.96,251.45 206.37,251.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "208.36,258.3 208.36,261.48 206.78,262.39 206.77,259.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.55,
    y: 259.2,
    transform: "matrix(1 -1.852139e-03 1.852139e-03 1 -0.4827 0.3814)",
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "203.77,258.75 203.77,261.93 204.55,262.39 204.55,259.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "193.33,256.45 193.33,264.13 194.9,265.03 195.45,257.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "194.9,257.36 194.9,265.03 197.13,265.03 198.69,256.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "197.13,257.36 197.13,265.03 198.7,264.13 198.7,261.58 197.92,260.68 198.69,258.4  198.69,256.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "195.15,256.34 196.87,256.34 197.13,257.36 194.9,257.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "193.93,255.63 195.15,256.34 194.9,257.36 193.33,256.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "193.93,254.63 193.93,255.63 193.33,256.45 193.32,255.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "196.87,256.34 198.09,255.63 198.69,256.45 197.13,257.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "198.09,255.63 198.1,254.63 198.7,255.16 198.69,256.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "195.15,253.93 196.87,253.93 198.1,254.63 198.09,255.63 196.87,256.34  195.15,256.34 193.93,255.63 193.93,254.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "193.7,255.18 193.7,255.77 195.05,256.55 195.53,255.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "195.06,255.96 195.05,256.55 196.97,256.55 198.32,255.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "196.97,255.96 196.97,256.55 198.32,255.78 198.32,255.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "198.32,254.08 198.32,255.18 196.97,255.96 195.05,255.96 193.7,255.18  193.7,254.08 195.05,253.3 196.97,253.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "194.31,252.95 194.31,254.96 195.3,255.54 195.66,253.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "195.3,253.53 195.3,255.54 196.71,255.54 197.71,252.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "196.71,253.53 196.71,255.54 197.71,254.96 197.71,252.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "197.71,252.14 197.71,252.95 196.71,253.53 195.3,253.53 194.3,252.95 194.3,252.14  195.3,251.56 196.71,251.56  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "198.7,258.4 198.7,261.58 197.12,262.49 197.12,259.31  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.89,
    y: 259.31,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "194.11,258.86 194.11,262.04 194.89,262.49 194.89,259.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "183.93,256.8 183.93,264.48 185.5,265.39 186.05,257.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "185.5,257.71 185.5,265.39 187.72,265.39 189.29,256.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "187.72,257.71 187.72,265.39 189.3,264.48 189.3,261.93 188.52,261.03  189.29,258.75 189.29,256.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "185.74,256.68 187.47,256.68 187.72,257.71 185.5,257.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "184.53,255.98 185.74,256.68 185.5,257.71 183.93,256.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "184.53,254.98 184.53,255.98 183.93,256.8 183.92,255.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "187.47,256.68 188.69,255.98 189.29,256.8 187.72,257.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "188.69,255.98 188.7,254.98 189.3,255.52 189.29,256.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "185.74,254.28 187.47,254.28 188.7,254.98 188.69,255.98 187.47,256.68  185.74,256.68 184.53,255.98 184.53,254.98  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "184.3,255.53 184.3,256.12 185.65,256.9 186.13,256.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "185.65,256.32 185.65,256.9 187.57,256.9 188.92,255.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "187.57,256.32 187.57,256.9 188.92,256.13 188.92,255.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "188.92,254.43 188.92,255.53 187.57,256.32 185.65,256.32 184.3,255.53  184.3,254.43 185.65,253.65 187.57,253.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "184.91,253.3 184.91,255.32 185.9,255.89 186.26,253.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "185.91,253.88 185.9,255.89 187.32,255.89 188.31,253.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "187.32,253.88 187.32,255.89 188.31,255.32 188.31,253.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "188.31,252.49 188.31,253.3 187.31,253.88 185.9,253.88 184.9,253.3 184.9,252.49  185.9,251.91 187.31,251.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "189.3,258.75 189.3,261.93 187.72,262.85 187.72,259.66  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.49,
    y: 259.66,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "184.71,259.21 184.71,262.39 185.49,262.85 185.49,259.66  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "175.22,255.35 175.22,263.03 176.79,263.93 177.35,255.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "176.79,256.26 176.79,263.93 179.02,263.93 180.59,255.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "179.02,256.26 179.02,263.93 180.59,263.03 180.59,260.49 179.82,259.58  180.59,257.3 180.59,255.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "177.04,255.23 178.77,255.23 179.02,256.26 176.79,256.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "175.82,254.53 177.04,255.23 176.79,256.26 175.22,255.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "175.82,253.53 175.82,254.53 175.22,255.35 175.22,254.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "178.77,255.23 179.99,254.53 180.59,255.35 179.02,256.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "179.99,254.53 179.99,253.53 180.59,254.07 180.59,255.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "177.04,252.83 178.77,252.83 179.99,253.53 179.99,254.53 178.77,255.23  177.04,255.23 175.82,254.53 175.82,253.53  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "175.6,254.09 175.6,254.67 176.95,255.46 177.43,254.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "176.95,254.87 176.95,255.46 178.87,255.46 180.22,254.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "178.87,254.87 178.87,255.46 180.22,254.68 180.22,254.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "180.22,252.98 180.22,254.09 178.86,254.87 176.95,254.87 175.59,254.09  175.59,252.98 176.95,252.2 178.86,252.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "176.2,251.85 176.2,253.87 177.2,254.44 177.55,252.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "177.2,252.43 177.2,254.44 178.61,254.44 179.61,251.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "178.61,252.43 178.61,254.44 179.61,253.87 179.61,251.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "179.61,251.03 179.61,251.85 178.61,252.43 177.2,252.43 176.2,251.85 176.2,251.03  177.2,250.46 178.61,250.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "180.59,257.3 180.59,260.49 179.02,261.39 179.01,258.21  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.79,
    y: 258.21,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "176.01,257.76 176.01,260.94 176.79,261.39 176.79,258.21  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "226.39,263.54 226.39,271.22 227.96,272.13 228.52,264.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "227.97,264.45 227.96,272.13 230.19,272.13 231.76,263.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "230.19,264.45 230.19,272.13 231.76,271.22 231.76,268.68 230.99,267.77  231.76,265.49 231.76,263.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "228.21,263.42 229.94,263.42 230.19,264.45 227.97,264.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "226.99,262.72 228.21,263.42 227.97,264.45 226.39,263.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "226.99,261.72 226.99,262.72 226.39,263.54 226.39,262.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "229.94,263.42 231.16,262.72 231.76,263.54 230.19,264.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "231.16,262.72 231.16,261.72 231.76,262.26 231.76,263.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "228.21,261.01 229.94,261.01 231.16,261.72 231.16,262.72 229.94,263.42  228.21,263.42 226.99,262.72 226.99,261.72  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "226.77,262.27 226.77,262.87 228.12,263.65 228.6,262.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "228.12,263.05 228.12,263.65 230.03,263.65 231.39,262.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "230.03,263.05 230.03,263.65 231.39,262.87 231.39,262.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "231.39,261.17 231.39,262.27 230.03,263.05 228.12,263.05 226.77,262.27  226.77,261.17 228.12,260.39 230.03,260.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "227.38,260.04 227.38,262.05 228.37,262.63 228.72,260.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "228.37,260.62 228.37,262.63 229.78,262.63 230.78,260.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "229.78,260.62 229.78,262.63 230.78,262.05 230.78,260.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "230.78,259.22 230.78,260.04 229.78,260.62 228.37,260.62 227.37,260.04  227.37,259.22 228.37,258.65 229.78,258.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "231.76,265.49 231.76,268.68 230.19,269.58 230.19,266.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.96,
    y: 266.4,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "227.17,265.94 227.17,269.13 227.96,269.58 227.96,266.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "216.56,264.1 216.56,271.77 218.14,272.68 218.69,264.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "218.14,265.01 218.14,272.68 220.36,272.68 221.93,264.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "220.36,265.01 220.36,272.68 221.93,271.77 221.93,269.24 221.16,268.33  221.93,266.05 221.93,264.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "218.38,263.98 220.11,263.98 220.36,265.01 218.14,265.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "217.16,263.28 218.38,263.98 218.14,265.01 216.56,264.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "217.16,262.28 217.16,263.28 216.56,264.1 216.56,262.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "220.11,263.98 221.33,263.28 221.93,264.1 220.36,265.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "221.33,263.28 221.33,262.28 221.93,262.82 221.93,264.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "218.38,261.58 220.11,261.58 221.33,262.28 221.33,263.28 220.11,263.98  218.38,263.98 217.16,263.28 217.16,262.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "216.94,262.84 216.94,263.42 218.29,264.21 218.77,263.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "218.29,263.62 218.29,264.21 220.2,264.21 221.56,262.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "220.2,263.62 220.2,264.21 221.56,263.42 221.56,262.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "221.56,261.73 221.56,262.84 220.2,263.62 218.29,263.62 216.94,262.84  216.94,261.73 218.29,260.95 220.2,260.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "217.54,260.6 217.54,262.62 218.54,263.19 218.89,260.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "218.54,261.18 218.54,263.19 219.95,263.19 220.95,260.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "219.95,261.18 219.95,263.19 220.95,262.62 220.95,260.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "220.95,259.78 220.95,260.6 219.95,261.18 218.54,261.18 217.54,260.6  217.54,259.78 218.54,259.21 219.95,259.21  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "221.93,266.05 221.93,269.24 220.36,270.14 220.35,266.96  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.13,
    y: 266.96,
    transform: "matrix(1 -1.382082e-03 1.382082e-03 1 -0.3709 0.3033)",
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "217.34,266.5 217.34,269.69 218.13,270.14 218.13,266.96  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "207.89,264.56 207.89,272.23 209.46,273.14 210.02,265.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "209.46,265.46 209.46,273.14 211.69,273.14 213.26,264.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "211.69,265.46 211.69,273.14 213.26,272.23 213.26,269.69 212.48,268.78  213.26,266.5 213.26,264.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "209.71,264.44 211.44,264.44 211.69,265.46 209.46,265.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "208.49,263.73 209.71,264.44 209.46,265.46 207.89,264.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "208.49,262.74 208.49,263.73 207.89,264.56 207.89,263.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "211.44,264.44 212.66,263.73 213.26,264.56 211.69,265.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "212.66,263.73 212.66,262.74 213.26,263.27 213.26,264.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "209.71,262.03 211.44,262.03 212.66,262.74 212.66,263.73 211.44,264.44  209.71,264.44 208.49,263.73 208.49,262.74  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "208.26,263.29 208.26,263.88 209.62,264.66 210.1,263.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "209.62,264.07 209.62,264.66 211.53,264.66 212.88,263.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "211.53,264.07 211.53,264.66 212.89,263.88 212.88,263.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "212.89,262.18 212.88,263.29 211.53,264.07 209.62,264.07 208.26,263.29  208.26,262.18 209.62,261.4 211.53,261.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "208.87,261.05 208.87,263.07 209.87,263.65 210.22,261.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "209.87,261.63 209.87,263.65 211.28,263.65 212.27,261.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "211.28,261.63 211.28,263.65 212.27,263.07 212.27,261.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "212.27,260.24 212.27,261.05 211.28,261.63 209.87,261.63 208.87,261.05  208.87,260.24 209.87,259.66 211.28,259.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "213.26,266.5 213.26,269.69 211.69,270.59 211.68,267.41  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.46,
    y: 267.41,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "208.67,266.96 208.67,270.14 209.46,270.59 209.46,267.41  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "199.59,265.12 199.59,272.79 201.17,273.7 201.72,265.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "201.17,266.03 201.17,273.7 203.39,273.7 204.96,265.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "203.39,266.03 203.39,273.7 204.96,272.79 204.96,270.25 204.19,269.34  204.96,267.06 204.96,265.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "201.41,265 203.14,265 203.39,266.03 201.17,266.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "200.19,264.29 201.41,265 201.17,266.03 199.59,265.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "200.19,263.3 200.19,264.29 199.59,265.12 199.59,263.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "203.14,265 204.36,264.29 204.96,265.12 203.39,266.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "204.36,264.29 204.36,263.3 204.96,263.83 204.96,265.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "201.41,262.59 203.14,262.59 204.36,263.3 204.36,264.29 203.14,265 201.41,265  200.19,264.29 200.19,263.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "199.97,263.85 199.97,264.44 201.32,265.22 201.8,264.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "201.32,264.63 201.32,265.22 203.24,265.22 204.59,263.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "203.24,264.63 203.24,265.22 204.59,264.44 204.59,263.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "204.59,262.74 204.59,263.85 203.23,264.63 201.32,264.63 199.97,263.85  199.97,262.74 201.32,261.96 203.23,261.96  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "200.57,261.61 200.57,263.63 201.57,264.21 201.93,261.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "201.57,262.19 201.57,264.21 202.98,264.21 203.98,261.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "202.98,262.19 202.98,264.21 203.98,263.63 203.98,261.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "203.98,260.8 203.98,261.61 202.98,262.19 201.57,262.19 200.57,261.61  200.57,260.8 201.57,260.22 202.98,260.22  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "204.96,267.06 204.96,270.25 203.39,271.16 203.39,267.98  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.16,
    y: 267.98,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "200.38,267.52 200.38,270.7 201.16,271.16 201.16,267.98  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "192.62,267 192.62,274.68 194.19,275.58 194.75,267.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "194.19,267.91 194.19,275.58 196.42,275.58 197.99,267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "196.42,267.91 196.42,275.58 197.99,274.68 197.99,272.14 197.22,271.23  197.99,268.95 197.99,267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "194.44,266.88 196.17,266.88 196.42,267.91 194.19,267.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "193.22,266.18 194.44,266.88 194.19,267.91 192.62,267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "193.22,265.18 193.22,266.18 192.62,267 192.62,265.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "196.17,266.88 197.39,266.18 197.99,267 196.42,267.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "197.39,266.18 197.39,265.18 197.99,265.72 197.99,267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "194.44,264.48 196.17,264.48 197.39,265.18 197.39,266.18 196.17,266.88  194.44,266.88 193.22,266.18 193.22,265.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "193,265.73 193,266.32 194.35,267.11 194.83,266.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "194.35,266.51 194.35,267.11 196.26,267.11 197.62,265.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "196.26,266.51 196.26,267.11 197.62,266.33 197.62,265.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "197.62,264.63 197.62,265.73 196.26,266.51 194.35,266.52 192.99,265.73  192.99,264.63 194.35,263.85 196.26,263.85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "193.6,263.5 193.6,265.52 194.6,266.09 194.95,263.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "194.6,264.08 194.6,266.09 196.01,266.09 197.01,263.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "196.01,264.08 196.01,266.09 197.01,265.52 197.01,263.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "197.01,262.69 197.01,263.5 196.01,264.08 194.6,264.08 193.6,263.5 193.6,262.69  194.6,262.11 196.01,262.11  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "197.99,268.95 197.99,272.14 196.41,273.05 196.41,269.87  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.19,
    y: 269.87,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "193.4,269.41 193.4,272.59 194.19,273.05 194.19,269.87  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "185.03,267.74 185.03,275.41 186.6,276.32 187.16,268.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "186.6,268.65 186.6,276.32 188.83,276.32 190.4,267.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "188.83,268.65 188.83,276.32 190.4,275.41 190.4,272.87 189.62,271.96 190.4,269.69  190.4,267.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "186.85,267.62 188.58,267.62 188.83,268.65 186.6,268.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "185.63,266.92 186.85,267.62 186.6,268.65 185.03,267.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "185.63,265.92 185.63,266.92 185.03,267.74 185.03,266.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "188.58,267.62 189.8,266.92 190.4,267.74 188.83,268.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "189.8,266.92 189.8,265.92 190.4,266.45 190.4,267.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "186.85,265.21 188.58,265.21 189.8,265.92 189.8,266.92 188.58,267.62  186.85,267.62 185.63,266.92 185.63,265.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "185.41,266.47 185.41,267.06 186.76,267.84 187.24,266.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "186.76,267.25 186.76,267.84 188.68,267.84 190.03,266.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "188.68,267.25 188.68,267.84 190.03,267.06 190.03,266.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "190.03,265.37 190.03,266.47 188.67,267.25 186.76,267.26 185.41,266.47  185.41,265.37 186.75,264.58 188.67,264.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "186.01,264.24 186.01,266.25 187.01,266.83 187.36,264.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "187.01,264.81 187.01,266.83 188.42,266.83 189.42,264.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "188.42,264.81 188.42,266.83 189.42,266.25 189.42,264.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "189.42,263.42 189.42,264.24 188.42,264.81 187.01,264.82 186.01,264.24  186.01,263.42 187.01,262.85 188.42,262.85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "190.4,269.69 190.4,272.87 188.82,273.78 188.82,270.59  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.6,
    y: 270.59,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "185.81,270.14 185.81,273.33 186.6,273.78 186.6,270.59  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "177,275.04 177,282.71 178.57,283.62 179.13,275.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "178.57,275.94 178.57,283.62 180.79,283.62 182.37,275.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "180.79,275.94 180.79,283.62 182.37,282.71 182.37,280.17 181.59,279.26  182.37,276.98 182.37,275.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "178.82,274.92 180.54,274.92 180.79,275.94 178.57,275.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "177.6,274.21 178.82,274.92 178.57,275.94 177,275.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "177.6,273.22 177.6,274.21 177,275.04 177,273.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "180.54,274.92 181.76,274.21 182.37,275.04 180.79,275.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "181.76,274.21 181.77,273.22 182.37,273.75 182.37,275.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "178.82,272.51 180.54,272.51 181.77,273.22 181.76,274.21 180.54,274.92  178.82,274.92 177.6,274.21 177.6,273.22  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "177.37,273.77 177.37,274.36 178.73,275.14 179.21,274.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "178.73,274.55 178.73,275.14 180.64,275.14 181.99,273.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "180.64,274.55 180.64,275.14 181.99,274.36 181.99,273.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "181.99,272.66 181.99,273.77 180.64,274.55 178.73,274.55 177.37,273.77  177.37,272.66 178.72,271.88 180.64,271.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "177.98,271.54 177.98,273.55 178.98,274.13 179.33,271.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "178.98,272.11 178.98,274.13 180.39,274.13 181.38,271.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "180.39,272.11 180.39,274.13 181.38,273.55 181.38,271.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "181.38,270.72 181.38,271.54 180.39,272.11 178.98,272.11 177.98,271.54  177.98,270.72 178.98,270.14 180.39,270.14  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "182.37,276.98 182.37,280.17 180.79,281.08 180.79,277.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.56,
    y: 277.9,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "177.78,277.44 177.78,280.62 178.56,281.08 178.56,277.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "239.64,269.16 239.64,276.83 241.21,277.74 241.76,269.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "241.21,270.06 241.21,277.74 243.43,277.74 245.01,269.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "243.43,270.06 243.43,277.74 245.01,276.83 245.01,274.29 244.23,273.38  245.01,271.1 245.01,269.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "241.46,269.03 243.19,269.03 243.43,270.06 241.21,270.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "240.24,268.33 241.46,269.03 241.21,270.06 239.64,269.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "240.24,267.33 240.24,268.33 239.64,269.16 239.64,267.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "243.19,269.03 244.41,268.33 245.01,269.16 243.43,270.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "244.41,268.33 244.41,267.33 245.01,267.87 245.01,269.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "241.46,266.63 243.19,266.63 244.41,267.33 244.41,268.33 243.19,269.03  241.46,269.03 240.24,268.33 240.24,267.33  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "240.01,267.89 240.01,268.48 241.37,269.26 241.84,268.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "241.37,268.67 241.37,269.26 243.28,269.26 244.63,267.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "243.28,268.67 243.28,269.26 244.63,268.48 244.63,267.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "244.63,266.78 244.63,267.89 243.28,268.67 241.37,268.67 240.01,267.89  240.01,266.78 241.36,266 243.28,266  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "240.62,265.65 240.62,267.67 241.62,268.24 241.97,266.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "241.62,266.23 241.62,268.24 243.03,268.24 244.02,265.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "243.03,266.23 243.03,268.24 244.02,267.67 244.02,265.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "244.02,264.84 244.02,265.65 243.03,266.23 241.62,266.23 240.62,265.65  240.62,264.84 241.61,264.26 243.03,264.26  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "245.01,271.1 245.01,274.29 243.43,275.2 243.43,272.01  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 272.01,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "240.42,271.56 240.42,274.74 241.2,275.2 241.2,272.01  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "235.56,275.14 235.56,282.82 237.13,283.73 237.69,275.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "237.13,276.05 237.13,283.73 239.35,283.73 240.93,275.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "239.35,276.05 239.35,283.73 240.93,282.82 240.93,280.27 240.15,279.37  240.93,277.09 240.93,275.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "237.38,275.03 239.1,275.03 239.35,276.05 237.13,276.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "236.16,274.32 237.38,275.03 237.13,276.05 235.56,275.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "236.16,273.32 236.16,274.32 235.56,275.14 235.55,273.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "239.1,275.03 240.32,274.32 240.93,275.15 239.35,276.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "240.32,274.32 240.33,273.32 240.93,273.86 240.93,275.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "237.38,272.62 239.1,272.62 240.33,273.32 240.32,274.32 239.1,275.03  237.38,275.03 236.16,274.32 236.16,273.32  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "235.93,273.87 235.93,274.46 237.28,275.24 237.77,274.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "237.29,274.66 237.28,275.24 239.2,275.24 240.55,273.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "239.2,274.66 239.2,275.24 240.55,274.46 240.55,273.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "240.55,272.77 240.55,273.87 239.2,274.66 237.28,274.66 235.93,273.87  235.93,272.77 237.28,271.99 239.2,271.99  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "236.54,271.64 236.54,273.66 237.54,274.23 237.89,272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "237.54,272.22 237.54,274.23 238.95,274.23 239.94,271.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "238.95,272.22 238.95,274.23 239.94,273.66 239.94,271.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "239.94,270.82 239.94,271.64 238.94,272.22 237.54,272.22 236.54,271.64  236.54,270.82 237.54,270.25 238.94,270.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "240.93,277.09 240.93,280.27 239.35,281.18 239.35,278  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.12,
    y: 278,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "236.34,277.55 236.34,280.73 237.12,281.18 237.12,278  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "226.89,270.98 226.89,278.67 228.46,279.57 229.02,271.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "228.46,271.9 228.46,279.57 230.68,279.57 232.26,270.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "230.68,271.9 230.68,279.57 232.26,278.67 232.26,276.12 231.49,275.21  232.26,272.94 232.26,270.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "228.71,270.87 230.44,270.87 230.68,271.9 228.46,271.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "227.49,270.16 228.71,270.87 228.46,271.9 226.89,270.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "227.49,269.16 227.49,270.16 226.89,270.98 226.89,269.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "230.44,270.87 231.66,270.16 232.26,270.99 230.68,271.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "231.66,270.16 231.66,269.16 232.26,269.7 232.26,270.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "228.71,268.46 230.44,268.46 231.66,269.16 231.66,270.16 230.44,270.87  228.71,270.87 227.49,270.16 227.49,269.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "227.26,269.72 227.26,270.3 228.62,271.09 229.1,270.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "228.62,270.5 228.62,271.09 230.53,271.09 231.88,269.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "230.53,270.5 230.53,271.09 231.88,270.31 231.88,269.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "231.88,268.61 231.88,269.72 230.53,270.5 228.62,270.5 227.26,269.72  227.26,268.61 228.62,267.83 230.53,267.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "227.87,267.48 227.87,269.5 228.87,270.07 229.22,267.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "228.87,268.06 228.87,270.07 230.28,270.07 231.28,267.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "230.28,268.06 230.28,270.07 231.28,269.5 231.28,267.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "231.28,266.67 231.28,267.48 230.28,268.06 228.87,268.06 227.87,267.48  227.87,266.67 228.87,266.09 230.28,266.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "232.26,272.94 232.26,276.12 230.68,277.02 230.68,273.85  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.46,
    y: 273.85,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "227.68,273.39 227.68,276.57 228.46,277.02 228.46,273.85  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "220.75,271.76 220.75,279.44 222.32,280.34 222.88,272.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "222.32,272.67 222.32,280.34 224.54,280.34 226.12,271.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "224.54,272.67 224.54,280.34 226.12,279.44 226.12,276.89 225.34,275.98  226.12,273.71 226.12,271.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "222.57,271.64 224.3,271.64 224.54,272.67 222.32,272.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "221.35,270.94 222.57,271.64 222.32,272.67 220.75,271.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "221.35,269.94 221.35,270.94 220.75,271.76 220.75,270.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "224.3,271.64 225.52,270.94 226.12,271.76 224.54,272.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "225.52,270.94 225.52,269.94 226.12,270.48 226.12,271.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "222.57,269.24 224.3,269.24 225.52,269.94 225.52,270.94 224.3,271.64  222.57,271.64 221.35,270.94 221.35,269.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "221.12,270.49 221.12,271.08 222.48,271.86 222.96,270.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "222.48,271.27 222.48,271.86 224.39,271.86 225.74,270.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "224.39,271.27 224.39,271.86 225.74,271.08 225.74,270.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "225.74,269.39 225.74,270.49 224.39,271.27 222.48,271.27 221.12,270.49  221.12,269.39 222.48,268.61 224.39,268.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "221.73,268.26 221.73,270.27 222.73,270.85 223.08,268.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "222.73,268.84 222.73,270.85 224.14,270.85 225.14,268.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "224.14,268.84 224.14,270.85 225.14,270.27 225.14,268.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "225.14,267.44 225.14,268.26 224.14,268.84 222.73,268.84 221.73,268.26  221.73,267.44 222.73,266.87 224.14,266.87  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "226.12,273.71 226.12,276.89 224.54,277.8 224.54,274.62  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.32,
    y: 274.62,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "221.53,274.17 221.53,277.35 222.32,277.8 222.32,274.62  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "211.96,270.67 211.96,278.34 213.53,279.25 214.09,271.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "213.53,271.58 213.53,279.25 215.75,279.25 217.33,270.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "215.75,271.58 215.75,279.25 217.33,278.34 217.33,275.8 216.55,274.89  217.33,272.62 217.33,270.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "213.78,270.55 215.5,270.55 215.75,271.58 213.53,271.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "212.55,269.84 213.78,270.55 213.53,271.58 211.96,270.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "212.55,268.84 212.55,269.84 211.96,270.67 211.95,269.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "215.5,270.55 216.73,269.84 217.33,270.67 215.75,271.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "216.73,269.84 216.73,268.84 217.33,269.38 217.33,270.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "213.78,268.15 215.5,268.15 216.73,268.84 216.73,269.84 215.5,270.55  213.78,270.55 212.55,269.84 212.55,268.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "212.33,269.4 212.33,269.99 213.69,270.77 214.16,269.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "213.69,270.18 213.69,270.77 215.6,270.77 216.95,269.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "215.6,270.18 215.6,270.77 216.95,269.99 216.95,269.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "216.95,268.3 216.95,269.4 215.59,270.18 213.69,270.18 212.33,269.4 212.33,268.3  213.68,267.52 215.59,267.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "212.94,267.17 212.94,269.18 213.93,269.76 214.29,267.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "213.94,267.75 213.93,269.76 215.34,269.76 216.34,267.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "215.34,267.75 215.34,269.76 216.34,269.18 216.34,267.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "216.34,266.35 216.34,267.17 215.34,267.75 213.93,267.75 212.94,267.17  212.94,266.35 213.93,265.77 215.34,265.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "217.33,272.62 217.33,275.8 215.75,276.71 215.75,273.53  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.52,
    y: 273.53,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "212.74,273.08 212.74,276.26 213.52,276.71 213.52,273.53  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "203.52,273.28 203.52,280.95 205.09,281.87 205.64,273.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "205.09,274.19 205.09,281.87 207.31,281.87 208.89,273.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "207.31,274.19 207.31,281.87 208.89,280.95 208.89,278.42 208.11,277.51  208.89,275.23 208.89,273.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "205.34,273.17 207.07,273.17 207.31,274.19 205.09,274.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "204.12,272.46 205.34,273.17 205.09,274.19 203.52,273.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "204.12,271.46 204.12,272.46 203.52,273.28 203.52,272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "207.07,273.17 208.29,272.46 208.89,273.29 207.31,274.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "208.29,272.46 208.29,271.46 208.89,272 208.89,273.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "205.34,270.76 207.07,270.76 208.29,271.46 208.29,272.46 207.07,273.17  205.34,273.17 204.12,272.46 204.12,271.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "203.89,272.01 203.89,272.6 205.25,273.38 205.73,272.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "205.25,272.8 205.25,273.38 207.16,273.38 208.51,272.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "207.16,272.8 207.16,273.38 208.52,272.6 208.51,272.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "208.52,270.91 208.51,272.01 207.16,272.8 205.25,272.8 203.89,272.01  203.89,270.91 205.24,270.13 207.16,270.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "204.5,269.78 204.5,271.79 205.5,272.38 205.85,270.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "205.5,270.36 205.5,272.38 206.91,272.38 207.91,269.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "206.91,270.36 206.91,272.38 207.91,271.79 207.91,269.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "207.91,268.96 207.91,269.78 206.91,270.36 205.5,270.36 204.5,269.78 204.5,268.96  205.5,268.39 206.91,268.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "208.89,275.23 208.89,278.42 207.31,279.33 207.31,276.14  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.09,
    y: 276.14,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "204.3,275.69 204.3,278.87 205.09,279.33 205.09,276.14  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "189.94,275.96 189.94,283.63 191.51,284.54 192.06,276.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "191.51,276.86 191.51,284.54 193.73,284.54 195.3,275.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "193.73,276.86 193.73,284.54 195.3,283.63 195.3,281.09 194.53,280.18 195.3,277.91  195.3,275.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "191.76,275.84 193.48,275.84 193.73,276.86 191.51,276.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "190.54,275.13 191.76,275.84 191.51,276.86 189.94,275.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "190.54,274.14 190.54,275.13 189.94,275.96 189.94,274.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "193.48,275.84 194.7,275.13 195.3,275.96 193.73,276.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "194.7,275.13 194.7,274.14 195.3,274.67 195.3,275.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "191.76,273.43 193.48,273.43 194.7,274.14 194.7,275.13 193.48,275.84  191.76,275.84 190.54,275.13 190.54,274.14  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "190.31,274.69 190.31,275.28 191.66,276.06 192.14,275.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "191.66,275.47 191.66,276.06 193.58,276.06 194.93,274.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "193.58,275.47 193.58,276.06 194.93,275.28 194.93,274.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "194.93,273.58 194.93,274.69 193.58,275.47 191.66,275.47 190.3,274.69  190.3,273.58 191.66,272.8 193.58,272.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "190.91,272.46 190.91,274.47 191.91,275.05 192.27,272.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "191.91,273.03 191.91,275.05 193.33,275.05 194.32,272.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "193.33,273.03 193.33,275.05 194.32,274.47 194.32,272.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "194.32,271.64 194.32,272.46 193.32,273.03 191.91,273.03 190.91,272.46  190.91,271.64 191.91,271.06 193.32,271.06  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "195.3,277.91 195.3,281.09 193.73,282 193.73,278.82  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.5,
    y: 278.82,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "190.71,278.36 190.71,281.54 191.5,282 191.5,278.82  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "190.96,286.37 190.96,282.25 196.01,279.33 203.15,279.33 208.19,282.25  208.19,286.37 203.15,289.28 196.01,289.28  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.01,
    y: 289.28,
    style: {
      fill: "#B5AFA7"
    },
    width: 7.14,
    height: 9.45
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "203.15,289.28 208.19,286.37 208.19,295.81 203.15,298.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "190.96,286.37 196.01,289.28 196.01,298.73 190.96,295.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "260.02,294.81 208.19,294.81 208.19,287.51 212.23,286.37 255.51,286.37  260.02,287.51  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.19,
    y: 285.22,
    style: {
      fill: "#E6E1DD"
    },
    width: 51.83,
    height: 2.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "379.84,367.74 379.84,407.75 376.73,409.55 376.73,369.54 376.89,368.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "376.73,369.54 376.73,409.55 262.22,343.58 262.22,303.57 370.25,364.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "379.84,367.74 265.34,301.77 262.22,303.57 376.73,369.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "365.38,436.75 240.98,365.07 240.98,360.69 365.38,432.36 366.66,433.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "365.38,432.36 240.98,360.69 270.2,343.82 394.6,415.49 385.44,423.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "365.38,436.75 394.6,419.87 394.6,415.49 365.38,432.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#544540"
    },
    points: "374.08,421.64 399.84,406.76 399.84,396.4 372.39,408.31 369.99,416.09  369.99,419.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#685750"
    },
    points: "374.08,411.27 399.84,396.4 393.5,385.4 366.04,397.32 363.65,405.09 367.28,409.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#836E69"
    },
    points: "367.73,400.28 393.5,385.4 256.95,306.72 231.18,321.6 258.7,342.14 359.46,398.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#403531"
    },
    points: "235.74,331.56 242.09,327.89 367.73,400.28 374.08,411.27 374.08,421.64  367.73,425.3 242.09,352.92 235.74,341.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "235.33,333.9 240.98,330.64 365.36,402.3 371.01,412.09 371.01,421.31 365.36,424.57  240.98,352.91 235.33,343.13  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "363.63,417.41 365.56,416.31 365.56,410.81 361.92,410.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "363.63,411.91 365.56,410.81 362.19,404.99 355.5,403.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "360.26,406.08 362.19,404.99 357.43,402.23 355.5,403.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "352.14,405.28 355.5,403.34 360.27,406.08 363.63,411.91 363.63,417.41  360.27,419.36 355.5,416.61 352.14,410.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "354.62,407.9 354.62,411.02 356.54,414.34 359.24,415.9 359.68,415.64  356.98,414.08 355.07,410.76 355.07,407.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "355.07,407.64 355.07,410.76 356.98,414.08 359.68,415.64 361.15,414.8  361.15,412.34 360.82,411.1 359.24,408.35 356.54,406.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "250.35,352.16 252.28,351.07 252.28,345.56 248.63,345.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "250.35,346.67 252.28,345.56 248.91,339.73 242.23,338.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "246.99,340.84 248.91,339.73 244.15,336.99 242.23,338.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "238.86,340.03 242.23,338.09 246.99,340.84 250.35,346.67 250.35,352.16  246.99,354.11 242.23,351.36 238.86,345.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "241.34,342.65 241.34,345.78 243.26,349.09 245.97,350.65 246.41,350.39  243.7,348.83 241.79,345.52 241.79,342.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "241.79,342.39 241.79,345.52 243.7,348.83 246.41,350.39 247.87,349.55  247.87,347.1 247.55,345.85 245.97,343.11 243.26,341.54  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "365.36,402.3 367.1,401.29 242.71,329.63 240.98,330.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "371.01,412.09 372.75,411.08 367.13,401.28 365.38,402.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "371.01,421.31 372.75,420.31 372.75,411.08 371.01,412.09  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "347.5,386.41 347.5,426.43 344.38,428.22 344.38,388.21 344.55,387.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "344.38,388.21 344.38,428.22 229.88,362.26 229.88,322.25 256.96,336.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "347.5,386.41 233,320.45 229.88,322.25 344.38,388.21  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "174.03,283.25 174.03,290.93 175.6,291.84 176.15,283.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "175.6,284.17 175.6,291.84 177.82,291.84 179.39,283.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "177.82,284.17 177.82,291.84 179.4,290.93 179.4,288.39 178.62,287.48  179.39,285.21 179.39,283.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "175.85,283.13 177.58,283.13 177.82,284.17 175.6,284.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "174.63,282.43 175.85,283.13 175.6,284.17 174.03,283.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "174.63,281.44 174.63,282.43 174.03,283.25 174.03,281.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "177.58,283.13 178.79,282.43 179.39,283.26 177.82,284.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "178.79,282.43 178.79,281.44 179.4,281.97 179.39,283.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "175.85,280.73 177.58,280.73 178.79,281.44 178.79,282.43 177.58,283.13  175.85,283.13 174.63,282.43 174.63,281.44  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "174.4,281.99 174.4,282.58 175.75,283.36 176.23,282.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "175.75,282.77 175.75,283.36 177.67,283.36 179.02,281.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "177.67,282.77 177.67,283.36 179.02,282.58 179.02,281.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "179.02,280.88 179.02,281.99 177.67,282.77 175.75,282.77 174.4,281.99  174.4,280.88 175.75,280.1 177.67,280.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "175,279.75 175,281.77 176.01,282.34 176.35,280.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "176.01,280.33 176.01,282.34 177.42,282.34 178.41,279.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "177.42,280.33 177.42,282.34 178.41,281.77 178.41,279.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "178.41,278.94 178.41,279.75 177.42,280.33 176.01,280.33 175,279.75 175,278.94  176,278.36 177.42,278.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "179.4,285.21 179.4,288.39 177.82,289.3 177.82,286.11  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.59,
    y: 286.11,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "174.81,285.66 174.81,288.85 175.59,289.3 175.59,286.11  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "183.55,283.49 183.55,291.16 185.12,292.07 185.68,284.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "185.13,284.39 185.12,292.07 187.34,292.07 188.92,283.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "187.34,284.39 187.34,292.07 188.92,291.16 188.92,288.62 188.14,287.71  188.92,285.44 188.92,283.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "185.37,283.37 187.1,283.37 187.34,284.39 185.13,284.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "184.15,282.67 185.37,283.37 185.13,284.39 183.55,283.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "184.15,281.66 184.15,282.67 183.55,283.49 183.55,282.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "187.1,283.37 188.32,282.67 188.92,283.49 187.34,284.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "188.32,282.67 188.32,281.66 188.92,282.21 188.92,283.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "185.37,280.96 187.1,280.96 188.32,281.66 188.32,282.67 187.1,283.37  185.37,283.37 184.15,282.67 184.15,281.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "183.92,282.22 183.92,282.81 185.28,283.59 185.76,282.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "185.28,283 185.28,283.59 187.19,283.59 188.54,282.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "187.19,283 187.19,283.59 188.54,282.81 188.54,282.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "188.54,281.12 188.54,282.22 187.19,283 185.28,283 183.92,282.22 183.92,281.12  185.27,280.33 187.19,280.33  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "184.53,279.99 184.53,282 185.53,282.58 185.88,280.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "185.53,280.56 185.53,282.58 186.94,282.58 187.94,279.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "186.94,280.56 186.94,282.58 187.94,282 187.94,279.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "187.94,279.17 187.94,279.99 186.93,280.56 185.53,280.56 184.53,279.99  184.53,279.17 185.53,278.59 186.93,278.59  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "188.92,285.44 188.92,288.62 187.34,289.53 187.34,286.34  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.11,
    y: 286.34,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "184.33,285.89 184.33,289.08 185.11,289.53 185.11,286.34  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "179.21,292.05 179.21,299.73 180.78,300.64 181.34,292.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "180.79,292.96 180.78,300.64 183.01,300.64 184.58,292.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "183.01,292.96 183.01,300.64 184.58,299.73 184.58,297.19 183.81,296.28  184.58,294 184.58,292.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "181.03,291.94 182.76,291.94 183.01,292.96 180.79,292.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "179.81,291.23 181.03,291.94 180.79,292.96 179.21,292.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "179.81,290.24 179.81,291.23 179.21,292.05 179.21,290.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "182.76,291.94 183.98,291.23 184.58,292.05 183.01,292.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "183.98,291.23 183.98,290.24 184.58,290.77 184.58,292.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "181.03,289.53 182.76,289.53 183.98,290.24 183.98,291.23 182.76,291.94  181.03,291.94 179.81,291.23 179.81,290.24  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "179.59,290.78 179.59,291.38 180.94,292.16 181.42,291.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "180.94,291.57 180.94,292.16 182.86,292.16 184.21,290.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "182.86,291.57 182.86,292.16 184.21,291.38 184.21,290.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "184.21,289.68 184.21,290.78 182.85,291.57 180.94,291.57 179.59,290.78  179.59,289.68 180.94,288.9 182.85,288.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "180.2,288.55 180.2,290.57 181.19,291.14 181.54,288.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "181.19,289.13 181.19,291.14 182.6,291.14 183.6,288.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "182.6,289.13 182.6,291.14 183.6,290.57 183.6,288.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "183.6,287.74 183.6,288.55 182.6,289.13 181.19,289.13 180.19,288.55  180.19,287.74 181.19,287.16 182.6,287.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "184.58,294 184.58,297.19 183.01,298.1 183.01,294.91  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.78,
    y: 294.91,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "180,294.46 180,297.64 180.78,298.1 180.78,294.91  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "187.08,294.43 187.08,302.11 188.65,303.02 189.21,295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "188.66,295.34 188.65,303.02 190.88,303.02 192.45,294.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "190.88,295.34 190.88,303.02 192.45,302.11 192.45,299.56 191.68,298.66  192.45,296.38 192.45,294.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "188.9,294.31 190.63,294.31 190.88,295.34 188.66,295.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "187.68,293.61 188.9,294.31 188.66,295.34 187.08,294.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "187.68,292.62 187.68,293.61 187.08,294.43 187.08,293.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "190.63,294.31 191.85,293.61 192.45,294.43 190.88,295.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "191.85,293.61 191.85,292.62 192.45,293.15 192.45,294.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "188.9,291.91 190.63,291.91 191.85,292.62 191.85,293.61 190.63,294.31  188.9,294.31 187.68,293.61 187.68,292.62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "187.46,293.16 187.46,293.75 188.81,294.54 189.29,293.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "188.81,293.94 188.81,294.54 190.72,294.54 192.07,293.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "190.72,293.94 190.72,294.54 192.07,293.75 192.07,293.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "192.07,292.06 192.07,293.16 190.72,293.94 188.81,293.94 187.45,293.16  187.45,292.06 188.81,291.28 190.72,291.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "188.06,290.93 188.06,292.95 189.06,293.52 189.41,291.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "189.06,291.5 189.06,293.52 190.47,293.52 191.47,290.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "190.47,291.5 190.47,293.52 191.47,292.95 191.47,290.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "191.47,290.12 191.47,290.93 190.47,291.5 189.06,291.5 188.06,290.93  188.06,290.12 189.06,289.54 190.47,289.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "192.45,296.38 192.45,299.56 190.87,300.48 190.87,297.29  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.65,
    y: 297.29,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "187.87,296.84 187.87,300.02 188.65,300.48 188.65,297.29  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "183.75,301.17 183.75,308.84 185.32,309.75 185.87,301.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "185.32,302.08 185.32,309.75 187.54,309.75 189.11,301.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "187.54,302.08 187.54,309.75 189.12,308.84 189.12,306.3 188.34,305.4  189.11,303.12 189.11,301.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "185.57,301.05 187.29,301.05 187.54,302.08 185.32,302.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "184.35,300.35 185.57,301.05 185.32,302.08 183.75,301.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "184.35,299.35 184.35,300.35 183.75,301.17 183.74,299.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "187.29,301.05 188.51,300.35 189.11,301.17 187.54,302.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "188.51,300.35 188.52,299.35 189.12,299.88 189.11,301.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "185.57,298.65 187.29,298.65 188.52,299.35 188.51,300.35 187.29,301.05  185.57,301.05 184.35,300.35 184.35,299.35  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "184.12,299.9 184.12,300.49 185.47,301.27 185.95,300.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "185.47,300.68 185.47,301.27 187.39,301.27 188.74,299.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "187.39,300.68 187.39,301.27 188.74,300.49 188.74,299.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "188.74,298.8 188.74,299.9 187.39,300.68 185.47,300.69 184.12,299.9 184.12,298.8  185.47,298.02 187.39,298.02  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "184.73,297.67 184.73,299.68 185.73,300.26 186.08,298.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "185.73,298.24 185.73,300.26 187.14,300.26 188.13,297.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "187.14,298.24 187.14,300.26 188.13,299.68 188.13,297.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "188.13,296.86 188.13,297.67 187.13,298.24 185.73,298.25 184.72,297.67  184.72,296.86 185.72,296.28 187.13,296.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "189.12,303.12 189.12,306.3 187.54,307.21 187.54,304.03  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.31,
    y: 304.03,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "184.53,303.58 184.53,306.76 185.31,307.21 185.31,304.03  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "192.8,300.72 192.8,308.4 194.38,309.3 194.93,301.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "194.38,301.63 194.38,309.3 196.6,309.3 198.17,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "196.6,301.63 196.6,309.3 198.17,308.4 198.17,305.86 197.4,304.95 198.17,302.67  198.17,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "194.62,300.6 196.35,300.6 196.6,301.63 194.38,301.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "193.4,299.9 194.62,300.6 194.38,301.63 192.8,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "193.4,298.9 193.4,299.9 192.8,300.72 192.8,299.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "196.35,300.6 197.57,299.9 198.17,300.72 196.6,301.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "197.57,299.9 197.57,298.9 198.17,299.44 198.17,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "194.62,298.2 196.35,298.2 197.57,298.9 197.57,299.9 196.35,300.6 194.62,300.6  193.4,299.9 193.4,298.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "193.18,299.45 193.18,300.04 194.53,300.83 195.01,299.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "194.53,300.24 194.53,300.83 196.45,300.83 197.8,299.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "196.45,300.24 196.45,300.83 197.8,300.05 197.8,299.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "197.8,298.35 197.8,299.45 196.44,300.24 194.53,300.24 193.18,299.45  193.18,298.35 194.53,297.57 196.44,297.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "193.79,297.22 193.79,299.24 194.78,299.81 195.13,297.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "194.78,297.8 194.78,299.81 196.19,299.81 197.19,297.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "196.19,297.8 196.19,299.81 197.19,299.24 197.19,297.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "197.19,296.4 197.19,297.22 196.19,297.8 194.78,297.8 193.79,297.22 193.79,296.4  194.78,295.83 196.19,295.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "198.17,302.67 198.17,305.86 196.6,306.76 196.6,303.58  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.37,
    y: 303.58,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "193.59,303.13 193.59,306.31 194.37,306.76 194.37,303.58  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "202.23,298.06 202.23,305.73 203.81,306.64 204.36,298.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "203.81,298.96 203.81,306.64 206.03,306.64 207.6,298.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "206.03,298.96 206.03,306.64 207.61,305.73 207.61,303.19 206.83,302.28  207.6,300.01 207.6,298.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "204.05,297.94 205.78,297.94 206.03,298.96 203.81,298.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "202.83,297.24 204.05,297.94 203.81,298.96 202.23,298.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "202.83,296.23 202.83,297.24 202.23,298.06 202.23,296.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "205.78,297.94 207,297.24 207.6,298.06 206.03,298.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "207,297.24 207.01,296.23 207.61,296.77 207.6,298.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "204.05,295.54 205.78,295.54 207.01,296.23 207,297.24 205.78,297.94  204.05,297.94 202.83,297.24 202.83,296.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "202.6,296.79 202.6,297.38 203.96,298.16 204.44,297.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "203.96,297.57 203.96,298.16 205.87,298.16 207.23,296.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "205.87,297.57 205.87,298.16 207.23,297.38 207.23,296.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "207.23,295.68 207.23,296.79 205.87,297.57 203.96,297.57 202.6,296.79  202.6,295.68 203.96,294.9 205.87,294.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "203.22,294.56 203.22,296.57 204.21,297.15 204.57,294.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "204.21,295.13 204.21,297.15 205.62,297.15 206.62,294.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "205.62,295.13 205.62,297.15 206.62,296.57 206.62,294.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "206.62,293.74 206.62,294.56 205.62,295.13 204.21,295.13 203.21,294.56  203.21,293.74 204.21,293.16 205.62,293.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "207.61,300.01 207.61,303.19 206.02,304.1 206.02,300.92  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.8,
    y: 300.92,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "203.02,300.46 203.02,303.64 203.8,304.1 203.8,300.92  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "207.72,302.52 207.72,310.2 209.29,311.1 209.85,303.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "209.3,303.43 209.29,311.1 211.52,311.1 213.09,302.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "211.52,303.43 211.52,311.1 213.09,310.2 213.09,307.65 212.32,306.75  213.09,304.47 213.09,302.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "209.54,302.4 211.27,302.4 211.52,303.43 209.3,303.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "208.32,301.7 209.54,302.4 209.3,303.43 207.72,302.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "208.32,300.7 208.32,301.7 207.72,302.52 207.72,301.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "211.27,302.4 212.49,301.7 213.09,302.52 211.52,303.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "212.49,301.7 212.49,300.7 213.09,301.24 213.09,302.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "209.54,299.99 211.27,299.99 212.49,300.7 212.49,301.7 211.27,302.4 209.54,302.4  208.32,301.7 208.32,300.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "208.1,301.25 208.1,301.84 209.45,302.62 209.93,301.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "209.45,302.03 209.45,302.62 211.36,302.62 212.71,301.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "211.36,302.03 211.36,302.62 212.72,301.84 212.71,301.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "212.72,300.15 212.71,301.25 211.36,302.03 209.45,302.03 208.09,301.25  208.09,300.15 209.45,299.37 211.36,299.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "208.7,299.02 208.7,301.03 209.7,301.61 210.05,299.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "209.7,299.59 209.7,301.61 211.11,301.61 212.11,299.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "211.11,299.59 211.11,301.61 212.11,301.03 212.11,299.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "212.11,298.2 212.11,299.02 211.1,299.59 209.7,299.59 208.7,299.02 208.7,298.2  209.7,297.63 211.1,297.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "213.09,304.47 213.09,307.65 211.51,308.56 211.51,305.38  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.29,
    y: 305.38,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "208.5,304.92 208.5,308.11 209.29,308.56 209.29,305.38  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "213.6,295.95 213.6,303.62 215.17,304.53 215.73,296.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "215.17,296.86 215.17,304.53 217.39,304.53 218.97,295.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "217.39,296.86 217.39,304.53 218.97,303.62 218.97,301.08 218.19,300.18  218.97,297.9 218.97,295.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "215.42,295.83 217.15,295.83 217.39,296.86 215.17,296.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "214.2,295.13 215.42,295.83 215.17,296.86 213.6,295.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "214.2,294.13 214.2,295.13 213.6,295.95 213.6,294.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "217.15,295.83 218.37,295.13 218.97,295.95 217.39,296.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "218.37,295.13 218.37,294.13 218.97,294.67 218.97,295.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "215.42,293.43 217.15,293.43 218.37,294.13 218.37,295.13 217.15,295.83  215.42,295.83 214.2,295.13 214.2,294.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "213.97,294.68 213.97,295.27 215.33,296.06 215.81,295.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "215.33,295.46 215.33,296.06 217.24,296.06 218.59,294.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "217.24,295.46 217.24,296.06 218.59,295.27 218.59,294.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "218.59,293.58 218.59,294.68 217.24,295.46 215.33,295.46 213.97,294.68  213.97,293.58 215.33,292.8 217.24,292.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "214.58,292.45 214.58,294.47 215.58,295.04 215.93,292.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "215.58,293.02 215.58,295.04 216.99,295.04 217.99,292.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "216.99,293.02 216.99,295.04 217.99,294.47 217.99,292.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "217.99,291.63 217.99,292.45 216.99,293.02 215.58,293.02 214.58,292.45  214.58,291.63 215.57,291.06 216.99,291.06  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "218.97,297.9 218.97,301.08 217.39,302 217.39,298.81  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.17,
    y: 298.81,
    transform: "matrix(1 -1.067302e-03 1.067302e-03 1 -0.3205 0.231)",
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "214.38,298.36 214.38,301.54 215.17,302 215.17,298.81  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "220.23,300.72 220.23,308.4 221.8,309.3 222.36,301.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "221.8,301.63 221.8,309.3 224.02,309.3 225.6,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "224.02,301.63 224.02,309.3 225.6,308.4 225.6,305.86 224.82,304.95 225.6,302.67  225.6,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "222.05,300.6 223.77,300.6 224.02,301.63 221.8,301.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "220.83,299.9 222.05,300.6 221.8,301.63 220.23,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "220.83,298.9 220.83,299.9 220.23,300.72 220.22,299.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "223.77,300.6 224.99,299.9 225.6,300.72 224.02,301.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "224.99,299.9 224.99,298.9 225.6,299.44 225.6,300.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "222.05,298.2 223.77,298.2 224.99,298.9 224.99,299.9 223.77,300.6 222.05,300.6  220.83,299.9 220.83,298.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "220.6,299.45 220.6,300.04 221.95,300.83 222.43,299.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "221.95,300.24 221.95,300.83 223.87,300.83 225.22,299.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "223.87,300.24 223.87,300.83 225.22,300.05 225.22,299.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "225.22,298.35 225.22,299.45 223.87,300.24 221.95,300.24 220.6,299.45  220.6,298.35 221.95,297.57 223.87,297.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "221.21,297.22 221.21,299.24 222.21,299.81 222.56,297.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "222.21,297.8 222.21,299.81 223.62,299.81 224.61,297.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "223.62,297.8 223.62,299.81 224.62,299.24 224.61,297.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "224.62,296.4 224.61,297.22 223.61,297.8 222.21,297.8 221.21,297.22 221.21,296.4  222.21,295.83 223.61,295.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "225.6,302.67 225.6,305.86 224.02,306.76 224.02,303.58  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.79,
    y: 303.58,
    transform: "matrix(1 -1.980692e-03 1.980692e-03 1 -0.604 0.4421)",
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "221.01,303.13 221.01,306.31 221.79,306.76 221.79,303.58  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "229.41,298.76 229.41,306.43 230.99,307.34 231.54,299.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "230.99,299.67 230.99,307.34 233.21,307.34 234.78,298.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "233.21,299.67 233.21,307.34 234.78,306.43 234.78,303.89 234,302.98  234.78,300.71 234.78,298.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "231.23,298.64 232.96,298.64 233.21,299.67 230.99,299.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "230.01,297.94 231.23,298.64 230.99,299.67 229.41,298.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "230.01,296.94 230.01,297.94 229.41,298.76 229.41,297.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "232.96,298.64 234.18,297.94 234.78,298.76 233.21,299.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "234.18,297.94 234.18,296.94 234.78,297.47 234.78,298.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "231.23,296.23 232.96,296.23 234.18,296.94 234.18,297.94 232.96,298.64  231.23,298.64 230.01,297.94 230.01,296.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "229.78,297.49 229.78,298.08 231.14,298.86 231.62,297.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "231.14,298.27 231.14,298.86 233.05,298.86 234.4,297.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "233.05,298.27 233.05,298.86 234.4,298.08 234.4,297.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "234.4,296.38 234.4,297.49 233.05,298.27 231.14,298.27 229.78,297.49  229.78,296.38 231.14,295.6 233.05,295.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "230.39,295.25 230.39,297.27 231.39,297.85 231.74,295.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "231.39,295.83 231.39,297.85 232.8,297.85 233.79,295.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "232.8,295.83 232.8,297.85 233.79,297.27 233.79,295.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "233.79,294.44 233.79,295.25 232.8,295.83 231.39,295.83 230.39,295.25  230.39,294.44 231.39,293.86 232.8,293.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "234.78,300.71 234.78,303.89 233.2,304.8 233.2,301.62  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.97,
    y: 301.62,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "230.19,301.16 230.19,304.34 230.97,304.8 230.97,301.62  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "238.12,305.66 238.12,313.34 239.69,314.25 240.25,306.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "239.69,306.58 239.69,314.25 241.92,314.25 243.49,305.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "241.92,306.58 241.92,314.25 243.49,313.34 243.49,310.8 242.71,309.89  243.49,307.61 243.49,305.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "239.94,305.55 241.67,305.55 241.92,306.58 239.69,306.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "238.72,304.84 239.94,305.55 239.69,306.58 238.12,305.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "238.72,303.85 238.72,304.84 238.12,305.66 238.12,304.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "241.67,305.55 242.89,304.84 243.49,305.67 241.92,306.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "242.89,304.84 242.89,303.85 243.49,304.38 243.49,305.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "239.94,303.14 241.67,303.14 242.89,303.85 242.89,304.84 241.67,305.55  239.94,305.55 238.72,304.84 238.72,303.85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "238.5,304.4 238.5,304.98 239.85,305.77 240.33,304.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "239.85,305.18 239.85,305.77 241.77,305.77 243.12,304.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "241.77,305.18 241.77,305.77 243.12,304.99 243.12,304.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "243.12,303.29 243.12,304.4 241.76,305.18 239.85,305.18 238.5,304.4 238.5,303.29  239.85,302.51 241.76,302.51  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "239.1,302.17 239.1,304.18 240.1,304.76 240.45,302.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "240.1,302.74 240.1,304.76 241.51,304.76 242.51,302.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "241.51,302.74 241.51,304.76 242.51,304.18 242.51,302.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "242.51,301.34 242.51,302.17 241.51,302.74 240.1,302.74 239.1,302.17  239.1,301.34 240.1,300.77 241.51,300.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "243.49,307.61 243.49,310.8 241.92,311.71 241.92,308.52  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.69,
    y: 308.52,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "238.9,308.07 238.9,311.26 239.69,311.71 239.69,308.52  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "233.77,311.86 233.77,319.54 235.34,320.45 235.89,312.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "235.34,312.77 235.34,320.45 237.56,320.45 239.14,311.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "237.56,312.77 237.56,320.45 239.14,319.54 239.14,317 238.36,316.09  239.14,313.81 239.14,311.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "235.59,311.75 237.32,311.75 237.56,312.77 235.34,312.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "234.37,311.04 235.59,311.75 235.34,312.77 233.77,311.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "234.37,310.04 234.37,311.04 233.77,311.86 233.77,310.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "237.32,311.75 238.54,311.04 239.14,311.87 237.56,312.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "238.54,311.04 238.54,310.04 239.14,310.58 239.14,311.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "235.59,309.34 237.32,309.34 238.54,310.04 238.54,311.04 237.32,311.75  235.59,311.75 234.37,311.04 234.37,310.04  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "234.14,310.6 234.14,311.18 235.49,311.97 235.97,311.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "235.49,311.38 235.49,311.97 237.41,311.97 238.76,310.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "237.41,311.38 237.41,311.97 238.76,311.19 238.76,310.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "238.76,309.49 238.76,310.6 237.41,311.38 235.49,311.38 234.14,310.6  234.14,309.49 235.49,308.7 237.41,308.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "234.75,308.36 234.75,310.38 235.75,310.95 236.1,308.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "235.75,308.94 235.75,310.95 237.16,310.95 238.16,308.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "237.16,308.94 237.16,310.95 238.16,310.38 238.16,308.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "238.16,307.55 238.16,308.36 237.16,308.94 235.75,308.94 234.75,308.36  234.75,307.55 235.74,306.97 237.16,306.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "239.14,313.81 239.14,317 237.56,317.91 237.56,314.72  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.33,
    y: 314.72,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "234.55,314.27 234.55,317.45 235.33,317.91 235.33,314.72  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "249.43,310.12 249.43,317.8 251,318.7 251.56,310.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "251.01,311.03 251,318.7 253.23,318.7 254.8,310.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "253.23,311.03 253.23,318.7 254.8,317.8 254.8,315.25 254.03,314.35 254.8,312.07  254.8,310.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "251.25,310 252.97,310 253.23,311.03 251.01,311.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "250.03,309.3 251.25,310 251.01,311.03 249.43,310.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "250.03,308.3 250.03,309.3 249.43,310.12 249.43,308.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "252.97,310 254.2,309.3 254.8,310.12 253.23,311.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "254.2,309.3 254.2,308.3 254.8,308.84 254.8,310.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "251.25,307.6 252.97,307.6 254.2,308.3 254.2,309.3 252.97,310 251.25,310  250.03,309.3 250.03,308.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "249.8,308.85 249.8,309.45 251.16,310.23 251.64,309.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "251.16,309.63 251.16,310.23 253.07,310.23 254.42,308.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "253.07,309.63 253.07,310.23 254.42,309.45 254.42,308.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "254.42,307.75 254.42,308.85 253.07,309.63 251.16,309.63 249.8,308.85  249.8,307.75 251.16,306.97 253.07,306.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "250.41,306.62 250.41,308.64 251.41,309.21 251.76,306.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "251.41,307.2 251.41,309.21 252.82,309.21 253.82,306.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "252.82,307.2 252.82,309.21 253.82,308.64 253.82,306.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "253.82,305.8 253.82,306.62 252.82,307.2 251.41,307.2 250.41,306.62 250.41,305.8  251.41,305.23 252.82,305.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "254.8,312.07 254.8,315.25 253.22,316.16 253.22,312.98  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 312.98,
    transform: "matrix(1 -1.540540e-03 1.540540e-03 1 -0.4843 0.3888)",
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "250.21,312.53 250.21,315.71 251,316.16 251,312.98  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "245.78,318.6 245.78,326.28 247.36,327.18 247.91,319.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "247.36,319.51 247.36,327.18 249.58,327.18 251.15,318.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "249.58,319.51 249.58,327.18 251.15,326.28 251.15,323.73 250.38,322.83  251.15,320.55 251.15,318.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "247.61,318.48 249.33,318.48 249.58,319.51 247.36,319.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "246.38,317.78 247.61,318.48 247.36,319.51 245.78,318.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "246.38,316.78 246.38,317.78 245.78,318.6 245.78,317.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "249.33,318.48 250.55,317.78 251.15,318.6 249.58,319.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "250.55,317.78 250.55,316.78 251.15,317.32 251.15,318.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "247.61,316.08 249.33,316.08 250.55,316.78 250.55,317.78 249.33,318.48  247.61,318.48 246.38,317.78 246.38,316.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "246.16,317.33 246.16,317.92 247.51,318.7 247.99,317.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "247.51,318.12 247.51,318.7 249.43,318.7 250.78,317.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "249.43,318.12 249.43,318.7 250.78,317.92 250.78,317.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "250.78,316.23 250.78,317.33 249.42,318.12 247.51,318.12 246.16,317.33  246.16,316.23 247.51,315.45 249.42,315.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "246.76,315.1 246.76,317.12 247.76,317.69 248.11,315.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "247.76,315.68 247.76,317.69 249.17,317.69 250.17,315.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "249.17,315.68 249.17,317.69 250.17,317.12 250.17,315.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "250.17,314.28 250.17,315.1 249.17,315.68 247.76,315.68 246.76,315.1  246.76,314.28 247.76,313.71 249.17,313.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "251.15,320.55 251.15,323.73 249.57,324.65 249.57,321.46  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.35,
    y: 321.46,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "246.57,321.01 246.57,324.19 247.35,324.65 247.35,321.46  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "257.17,315.44 257.17,323.12 258.74,324.02 259.3,316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "258.74,316.34 258.74,324.02 260.97,324.02 262.54,315.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "260.97,316.34 260.97,324.02 262.54,323.12 262.54,320.57 261.77,319.66  262.54,317.39 262.54,315.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "258.99,315.32 260.72,315.32 260.97,316.34 258.74,316.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "257.77,314.61 258.99,315.32 258.74,316.34 257.17,315.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "257.77,313.62 257.77,314.61 257.17,315.44 257.17,314.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "260.72,315.32 261.94,314.61 262.54,315.44 260.97,316.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "261.94,314.61 261.95,313.62 262.54,314.15 262.54,315.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "258.99,312.91 260.72,312.91 261.95,313.62 261.94,314.61 260.72,315.32  258.99,315.32 257.77,314.61 257.77,313.62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "257.55,314.17 257.55,314.75 258.9,315.54 259.38,314.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "258.9,314.95 258.9,315.54 260.81,315.54 262.17,314.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "260.81,314.95 260.81,315.54 262.17,314.76 262.17,314.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "262.17,313.06 262.17,314.17 260.81,314.95 258.9,314.95 257.54,314.17  257.54,313.06 258.9,312.28 260.81,312.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "258.15,311.93 258.15,313.95 259.15,314.53 259.5,312.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "259.15,312.51 259.15,314.53 260.56,314.53 261.56,311.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "260.56,312.51 260.56,314.53 261.56,313.95 261.56,311.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "261.56,311.12 261.56,311.93 260.56,312.51 259.15,312.51 258.15,311.93  258.15,311.12 259.15,310.54 260.56,310.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "262.54,317.39 262.54,320.57 260.97,321.47 260.97,318.29  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.74,
    y: 318.29,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "257.95,317.84 257.95,321.02 258.74,321.47 258.74,318.29  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "259.37,323.19 259.37,330.86 260.94,331.77 261.5,323.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "260.94,324.09 260.94,331.77 263.17,331.77 264.74,323.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "263.17,324.09 263.17,331.77 264.74,330.86 264.74,328.32 263.96,327.42  264.74,325.14 264.74,323.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "261.19,323.07 262.92,323.07 263.17,324.09 260.94,324.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "259.97,322.37 261.19,323.07 260.94,324.09 259.37,323.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "259.97,321.37 259.97,322.37 259.37,323.19 259.37,321.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "262.92,323.07 264.13,322.37 264.74,323.19 263.17,324.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "264.13,322.37 264.14,321.37 264.74,321.9 264.74,323.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "261.19,320.67 262.92,320.67 264.14,321.37 264.13,322.37 262.92,323.07  261.19,323.07 259.97,322.37 259.97,321.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "259.74,321.92 259.74,322.51 261.09,323.29 261.57,322.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "261.1,322.7 261.09,323.29 263.01,323.29 264.36,321.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "263.01,322.7 263.01,323.29 264.36,322.51 264.36,321.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "264.36,320.81 264.36,321.92 263,322.7 261.09,322.71 259.74,321.92 259.74,320.81  261.09,320.03 263,320.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "260.35,319.68 260.35,321.7 261.35,322.28 261.7,320.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "261.35,320.26 261.35,322.28 262.76,322.28 263.75,319.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "262.76,320.26 262.76,322.28 263.76,321.7 263.75,319.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "263.76,318.87 263.75,319.68 262.75,320.26 261.35,320.26 260.35,319.68  260.35,318.87 261.35,318.29 262.75,318.29  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "264.74,325.14 264.74,328.32 263.16,329.23 263.16,326.05  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.94,
    y: 326.05,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "260.15,325.59 260.15,328.78 260.94,329.23 260.94,326.05  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "265.51,317.42 265.51,325.09 267.08,326.01 267.64,317.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "267.08,318.33 267.08,326.01 269.31,326.01 270.88,317.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "269.31,318.33 269.31,326.01 270.88,325.09 270.88,322.56 270.11,321.65  270.88,319.37 270.88,317.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "267.33,317.3 269.06,317.3 269.31,318.33 267.08,318.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "266.11,316.6 267.33,317.3 267.08,318.33 265.51,317.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "266.11,315.6 266.11,316.6 265.51,317.42 265.51,316.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "269.06,317.3 270.28,316.6 270.88,317.42 269.31,318.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "270.28,316.6 270.29,315.6 270.88,316.14 270.88,317.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "267.33,314.9 269.06,314.9 270.29,315.6 270.28,316.6 269.06,317.3 267.33,317.3  266.11,316.6 266.11,315.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "265.89,316.16 265.89,316.75 267.24,317.52 267.72,316.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "267.24,316.93 267.24,317.52 269.15,317.52 270.51,316.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "269.15,316.93 269.15,317.52 270.51,316.75 270.51,316.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "270.51,315.05 270.51,316.16 269.15,316.93 267.24,316.94 265.88,316.16  265.88,315.05 267.24,314.27 269.15,314.27  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "266.5,313.92 266.5,315.94 267.5,316.51 267.84,314.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "267.5,314.5 267.5,316.51 268.9,316.51 269.9,313.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "268.9,314.5 268.9,316.51 269.9,315.94 269.9,313.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "269.9,313.1 269.9,313.92 268.9,314.5 267.5,314.5 266.5,313.92 266.5,313.1  267.49,312.53 268.9,312.53  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "270.88,319.37 270.88,322.56 269.31,323.46 269.3,320.28  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.08,
    y: 320.28,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "266.3,319.83 266.3,323.01 267.08,323.46 267.08,320.28  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "271.86,327.6 271.86,335.27 273.44,336.18 273.99,328.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "273.44,328.51 273.44,336.18 275.66,336.18 277.23,327.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "275.66,328.51 275.66,336.18 277.23,335.27 277.23,332.73 276.46,331.83  277.23,329.55 277.23,327.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "273.68,327.48 275.41,327.48 275.66,328.51 273.44,328.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "272.46,326.78 273.68,327.48 273.44,328.51 271.86,327.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "272.46,325.78 272.46,326.78 271.86,327.6 271.86,326.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "275.41,327.48 276.63,326.78 277.23,327.6 275.66,328.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "276.63,326.78 276.63,325.78 277.23,326.32 277.23,327.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "273.68,325.08 275.41,325.08 276.63,325.78 276.63,326.78 275.41,327.48  273.68,327.48 272.46,326.78 272.46,325.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "272.24,326.33 272.24,326.92 273.59,327.7 274.07,326.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "273.59,327.11 273.59,327.7 275.51,327.7 276.85,326.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "275.51,327.11 275.51,327.7 276.86,326.92 276.85,326.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "276.86,325.22 276.85,326.33 275.5,327.11 273.59,327.12 272.23,326.33  272.23,325.22 273.59,324.45 275.5,324.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "272.84,324.09 272.84,326.12 273.84,326.69 274.19,324.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "273.84,324.67 273.84,326.69 275.25,326.69 276.25,324.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "275.25,324.67 275.25,326.69 276.25,326.12 276.25,324.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "276.25,323.28 276.25,324.09 275.25,324.67 273.84,324.67 272.84,324.09  272.84,323.28 273.84,322.71 275.25,322.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "277.23,329.55 277.23,332.73 275.66,333.64 275.66,330.46  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.43,
    y: 330.46,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "272.64,330 272.64,333.19 273.43,333.64 273.43,330.46  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "279.67,325.79 279.67,333.47 281.24,334.38 281.8,326.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "281.24,326.7 281.24,334.38 283.47,334.38 285.04,325.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "283.47,326.7 283.47,334.38 285.04,333.47 285.04,330.93 284.26,330.02  285.04,327.75 285.04,325.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "281.49,325.67 283.21,325.67 283.47,326.7 281.24,326.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "280.27,324.97 281.49,325.67 281.24,326.7 279.67,325.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "280.27,323.97 280.27,324.97 279.67,325.79 279.67,324.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "283.21,325.67 284.44,324.97 285.04,325.79 283.47,326.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "284.44,324.97 284.44,323.97 285.04,324.51 285.04,325.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "281.49,323.27 283.21,323.27 284.44,323.97 284.44,324.97 283.21,325.67  281.49,325.67 280.27,324.97 280.27,323.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "280.04,324.53 280.04,325.12 281.4,325.9 281.87,325.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "281.4,325.31 281.4,325.9 283.31,325.9 284.66,324.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "283.31,325.31 283.31,325.9 284.66,325.12 284.66,324.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "284.66,323.42 284.66,324.53 283.31,325.31 281.4,325.31 280.04,324.53  280.04,323.42 281.4,322.64 283.31,322.64  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "280.65,322.29 280.65,324.31 281.65,324.88 282,322.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "281.65,322.87 281.65,324.88 283.06,324.88 284.05,322.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "283.06,322.87 283.06,324.88 284.06,324.31 284.05,322.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "284.06,321.47 284.05,322.29 283.06,322.87 281.65,322.87 280.65,322.29  280.65,321.47 281.65,320.9 283.06,320.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "285.04,327.75 285.04,330.93 283.46,331.84 283.46,328.65  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.24,
    y: 328.65,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "280.46,328.2 280.46,331.39 281.24,331.84 281.24,328.65  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "279.67,337.86 279.67,345.54 281.24,346.45 281.8,338.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "281.24,338.77 281.24,346.45 283.47,346.45 285.04,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "283.47,338.77 283.47,346.45 285.04,345.54 285.04,342.99 284.26,342.09  285.04,339.81 285.04,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "281.49,337.74 283.21,337.74 283.47,338.77 281.24,338.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "280.27,337.04 281.49,337.74 281.24,338.77 279.67,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "280.27,336.04 280.27,337.04 279.67,337.86 279.67,336.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "283.21,337.74 284.44,337.04 285.04,337.86 283.47,338.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "284.44,337.04 284.44,336.04 285.04,336.58 285.04,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "281.49,335.34 283.21,335.34 284.44,336.04 284.44,337.04 283.21,337.74  281.49,337.74 280.27,337.04 280.27,336.04  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "280.04,336.59 280.04,337.18 281.4,337.96 281.87,337.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "281.4,337.37 281.4,337.96 283.31,337.96 284.66,336.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "283.31,337.37 283.31,337.96 284.67,337.18 284.66,336.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "284.67,335.49 284.66,336.59 283.31,337.37 281.4,337.37 280.04,336.59  280.04,335.49 281.4,334.7 283.31,334.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "280.65,334.36 280.65,336.38 281.65,336.96 282,334.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "281.65,334.93 281.65,336.96 283.06,336.96 284.06,334.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "283.06,334.93 283.06,336.96 284.06,336.38 284.06,334.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "284.06,333.54 284.06,334.36 283.06,334.93 281.65,334.94 280.65,334.36  280.65,333.54 281.65,332.97 283.06,332.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "285.04,339.81 285.04,342.99 283.47,343.9 283.46,340.72  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.24,
    y: 340.72,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "280.46,340.27 280.46,343.45 281.24,343.9 281.24,340.72  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "289.22,330.21 289.22,337.88 290.8,338.79 291.35,330.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "290.8,331.11 290.8,338.79 293.02,338.79 294.59,330.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "293.02,331.11 293.02,338.79 294.59,337.88 294.59,335.34 293.81,334.43  294.59,332.16 294.59,330.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "291.04,330.09 292.77,330.09 293.02,331.11 290.8,331.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "289.82,329.39 291.04,330.09 290.8,331.11 289.22,330.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "289.82,328.39 289.82,329.39 289.22,330.21 289.22,328.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "292.77,330.09 293.99,329.39 294.59,330.21 293.02,331.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "293.99,329.39 293.99,328.39 294.59,328.92 294.59,330.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "291.04,327.68 292.77,327.68 293.99,328.39 293.99,329.39 292.77,330.09  291.04,330.09 289.82,329.39 289.82,328.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "289.59,328.94 289.59,329.53 290.95,330.31 291.43,329.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "290.95,329.72 290.95,330.31 292.86,330.31 294.21,328.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "292.86,329.72 292.86,330.31 294.21,329.53 294.21,328.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "294.21,327.83 294.21,328.94 292.86,329.72 290.95,329.72 289.59,328.94  289.59,327.83 290.95,327.05 292.86,327.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "290.2,326.7 290.2,328.72 291.2,329.3 291.55,327.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "291.2,327.28 291.2,329.3 292.61,329.3 293.61,326.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "292.61,327.28 292.61,329.3 293.61,328.72 293.61,326.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "293.61,325.89 293.61,326.7 292.61,327.28 291.2,327.28 290.2,326.7 290.2,325.89  291.2,325.31 292.61,325.31  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "294.59,332.16 294.59,335.34 293.01,336.25 293.01,333.07  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.78,
    y: 333.07,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "290,332.61 290,335.79 290.78,336.25 290.78,333.07  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "291.91,339.83 291.91,347.51 293.48,348.41 294.04,340.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "293.48,340.73 293.48,348.41 295.71,348.41 297.28,339.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "295.71,340.73 295.71,348.41 297.28,347.51 297.28,344.96 296.5,344.05  297.28,341.78 297.28,339.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "293.73,339.71 295.46,339.71 295.71,340.73 293.48,340.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "292.51,339 293.73,339.71 293.48,340.73 291.91,339.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "292.51,338.01 292.51,339 291.91,339.83 291.91,338.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "295.46,339.71 296.67,339 297.28,339.83 295.71,340.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "296.67,339 296.67,338.01 297.28,338.55 297.28,339.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "293.73,337.31 295.46,337.31 296.67,338.01 296.67,339 295.46,339.71  293.73,339.71 292.51,339 292.51,338.01  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "292.28,338.56 292.28,339.15 293.64,339.93 294.11,339.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "293.64,339.34 293.64,339.93 295.55,339.93 296.9,338.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "295.55,339.34 295.55,339.93 296.9,339.15 296.9,338.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "296.9,337.46 296.9,338.56 295.55,339.34 293.64,339.34 292.28,338.56  292.28,337.46 293.64,336.67 295.55,336.67  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "292.89,336.32 292.89,338.34 293.89,338.92 294.24,336.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "293.89,336.9 293.89,338.92 295.3,338.92 296.29,336.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "295.3,336.9 295.3,338.92 296.3,338.34 296.29,336.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "296.3,335.51 296.29,336.32 295.29,336.9 293.89,336.9 292.89,336.32  292.89,335.51 293.88,334.94 295.29,334.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "297.28,341.78 297.28,344.96 295.71,345.87 295.7,342.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "295.7,342.69 295.71,345.87 293.48,345.87 293.48,342.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "292.69,342.24 292.69,345.42 293.48,345.87 293.48,342.69  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "301.09,337.86 301.09,345.54 302.67,346.45 303.22,338.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "302.67,338.77 302.67,346.45 304.89,346.45 306.46,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "304.89,338.77 304.89,346.45 306.46,345.54 306.46,343 305.68,342.09  306.46,339.82 306.46,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "302.91,337.75 304.64,337.75 304.89,338.77 302.67,338.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "301.69,337.04 302.91,337.75 302.67,338.77 301.09,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "301.69,336.05 301.69,337.04 301.09,337.86 301.09,336.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "304.64,337.75 305.86,337.04 306.46,337.86 304.89,338.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "305.86,337.04 305.86,336.05 306.46,336.58 306.46,337.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "302.91,335.34 304.64,335.34 305.86,336.05 305.86,337.04 304.64,337.75  302.91,337.75 301.69,337.04 301.69,336.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "301.46,336.6 301.46,337.19 302.82,337.97 303.3,337.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "302.82,337.38 302.82,337.97 304.73,337.97 306.08,336.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "304.73,337.38 304.73,337.97 306.08,337.19 306.08,336.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "306.08,335.49 306.08,336.6 304.73,337.38 302.82,337.38 301.46,336.6  301.46,335.49 302.81,334.71 304.73,334.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "302.07,334.36 302.07,336.38 303.07,336.96 303.42,334.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "303.07,334.94 303.07,336.96 304.48,336.96 305.48,334.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "304.48,334.94 304.48,336.96 305.48,336.38 305.48,334.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "305.48,333.55 305.48,334.36 304.48,334.94 303.07,334.94 302.07,334.36  302.07,333.55 303.07,332.97 304.48,332.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "306.46,339.82 306.46,343 304.88,343.91 304.88,340.73  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.65,
    y: 340.73,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "301.87,340.27 301.87,343.45 302.65,343.91 302.65,340.73  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "309.8,344.77 309.8,352.45 311.37,353.36 311.93,345.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "311.37,345.69 311.37,353.36 313.6,353.36 315.17,344.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "313.6,345.69 313.6,353.36 315.17,352.45 315.17,349.91 314.4,349 315.17,346.72  315.17,344.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "311.62,344.65 313.35,344.65 313.6,345.69 311.37,345.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "310.4,343.95 311.62,344.65 311.37,345.69 309.8,344.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "310.4,342.95 310.4,343.95 309.8,344.77 309.8,343.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "313.35,344.65 314.58,343.95 315.17,344.77 313.6,345.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "314.58,343.95 314.58,342.95 315.17,343.49 315.17,344.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "311.62,342.25 313.35,342.25 314.58,342.95 314.58,343.95 313.35,344.65  311.62,344.65 310.4,343.95 310.4,342.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "310.18,343.51 310.18,344.09 311.53,344.88 312.01,344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "311.53,344.29 311.53,344.88 313.45,344.88 314.8,343.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "313.45,344.29 313.45,344.88 314.8,344.1 314.8,343.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "314.8,342.4 314.8,343.51 313.44,344.29 311.53,344.29 310.18,343.51 310.18,342.4  311.53,341.62 313.44,341.62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "310.78,341.27 310.78,343.29 311.79,343.86 312.13,341.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "311.79,341.85 311.79,343.86 313.2,343.86 314.19,341.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "313.2,341.85 313.2,343.86 314.19,343.29 314.19,341.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "314.19,340.45 314.19,341.27 313.19,341.85 311.79,341.85 310.78,341.27  310.78,340.45 311.78,339.88 313.19,339.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "315.17,346.72 315.17,349.91 313.6,350.82 313.6,347.63  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.37,
    y: 347.63,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "310.59,347.18 310.59,350.37 311.37,350.82 311.37,347.63  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "305.45,350.97 305.45,358.65 307.02,359.55 307.57,351.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "307.02,351.88 307.02,359.55 309.24,359.55 310.82,350.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "309.24,351.88 309.24,359.55 310.82,358.65 310.82,356.1 310.04,355.19  310.82,352.92 310.82,350.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "307.27,350.85 309,350.85 309.24,351.88 307.02,351.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "306.05,350.15 307.27,350.85 307.02,351.88 305.45,350.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "306.05,349.15 306.05,350.15 305.45,350.97 305.45,349.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "309,350.85 310.22,350.15 310.82,350.97 309.24,351.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "310.22,350.15 310.22,349.15 310.82,349.68 310.82,350.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "307.27,348.45 309,348.45 310.22,349.15 310.22,350.15 309,350.85 307.27,350.85  306.05,350.15 306.05,349.15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "305.82,349.7 305.82,350.29 307.17,351.07 307.66,350.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "307.17,350.48 307.17,351.07 309.09,351.07 310.44,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "309.09,350.48 309.09,351.07 310.44,350.3 310.44,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "310.44,348.6 310.44,349.7 309.09,350.48 307.17,350.49 305.82,349.7 305.82,348.6  307.17,347.81 309.09,347.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "306.42,347.47 306.42,349.48 307.43,350.06 307.78,347.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "307.43,348.05 307.43,350.06 308.84,350.06 309.84,347.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "308.84,348.05 308.84,350.06 309.84,349.48 309.84,347.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "309.84,346.66 309.84,347.47 308.84,348.05 307.43,348.05 306.42,347.47  306.42,346.66 307.42,346.08 308.84,346.08  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "310.82,352.92 310.82,356.1 309.24,357.01 309.24,353.83  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.01,
    y: 353.83,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "306.23,353.38 306.23,356.56 307.01,357.01 307.01,353.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "321.11,349.23 321.11,356.91 322.68,357.81 323.24,349.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "322.69,350.14 322.68,357.81 324.91,357.81 326.48,349.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "324.91,350.14 324.91,357.81 326.48,356.91 326.48,354.36 325.71,353.45  326.48,351.18 326.48,349.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "322.93,349.11 324.65,349.11 324.91,350.14 322.69,350.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "321.71,348.41 322.93,349.11 322.69,350.14 321.11,349.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "321.71,347.41 321.71,348.41 321.11,349.23 321.11,347.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "324.65,349.11 325.88,348.41 326.48,349.23 324.91,350.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "325.88,348.41 325.88,347.41 326.48,347.95 326.48,349.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "322.93,346.71 324.65,346.71 325.88,347.41 325.88,348.41 324.65,349.11  322.93,349.11 321.71,348.41 321.71,347.41  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "321.48,347.96 321.48,348.55 322.84,349.33 323.32,348.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "322.84,348.74 322.84,349.33 324.75,349.33 326.1,347.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "324.75,348.74 324.75,349.33 326.1,348.55 326.1,347.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "326.1,346.86 326.1,347.96 324.75,348.74 322.84,348.74 321.48,347.96  321.48,346.86 322.84,346.08 324.75,346.08  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "322.09,345.73 322.09,347.75 323.09,348.32 323.44,346.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "323.09,346.3 323.09,348.32 324.5,348.32 325.5,345.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "324.5,346.3 324.5,348.32 325.5,347.75 325.5,345.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "325.5,344.91 325.5,345.73 324.5,346.3 323.09,346.3 322.09,345.73 322.09,344.91  323.09,344.34 324.5,344.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "326.48,351.18 326.48,354.36 324.9,355.27 324.9,352.09  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.68,
    y: 352.09,
    transform: "matrix(1 -1.540588e-03 1.540588e-03 1 -0.5445 0.4992)",
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "321.89,351.64 321.89,354.82 322.68,355.27 322.68,352.09  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "317.46,357.71 317.46,365.38 319.04,366.29 319.59,358.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "319.04,358.62 319.04,366.29 321.26,366.29 322.83,357.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "321.26,358.62 321.26,366.29 322.83,365.38 322.83,362.84 322.06,361.93  322.83,359.66 322.83,357.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "319.29,357.59 321.01,357.59 321.26,358.62 319.04,358.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "318.07,356.88 319.29,357.59 319.04,358.62 317.46,357.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "318.07,355.89 318.07,356.88 317.46,357.71 317.46,356.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "321.01,357.59 322.23,356.88 322.83,357.71 321.26,358.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "322.23,356.88 322.23,355.89 322.83,356.42 322.83,357.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "319.29,355.19 321.01,355.19 322.23,355.89 322.23,356.88 321.01,357.59  319.29,357.59 318.07,356.88 318.07,355.89  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "317.84,356.44 317.84,357.03 319.19,357.81 319.67,356.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "319.19,357.22 319.19,357.81 321.11,357.81 322.46,356.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "321.11,357.22 321.11,357.81 322.46,357.03 322.46,356.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "322.46,355.34 322.46,356.44 321.1,357.22 319.19,357.22 317.84,356.44  317.84,355.34 319.19,354.56 321.1,354.56  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "318.44,354.21 318.44,356.22 319.44,356.8 319.79,354.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "319.44,354.78 319.44,356.8 320.85,356.8 321.85,354.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "320.85,354.78 320.85,356.8 321.85,356.22 321.85,354.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "321.85,353.39 321.85,354.21 320.85,354.78 319.44,354.79 318.44,354.21  318.44,353.39 319.44,352.81 320.85,352.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "322.83,359.66 322.83,362.84 321.25,363.75 321.25,360.57  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.03,
    y: 360.57,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "318.25,360.11 318.25,363.3 319.03,363.75 319.03,360.57  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "328.85,354.54 328.85,362.22 330.42,363.12 330.98,355.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "330.42,355.45 330.42,363.12 332.65,363.12 334.22,354.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "332.65,355.45 332.65,363.12 334.22,362.22 334.22,359.68 333.45,358.77  334.22,356.49 334.22,354.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "330.67,354.42 332.4,354.42 332.65,355.45 330.42,355.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "329.45,353.72 330.67,354.42 330.42,355.45 328.85,354.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "329.45,352.72 329.45,353.72 328.85,354.54 328.85,353.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "332.4,354.42 333.62,353.72 334.22,354.54 332.65,355.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "333.62,353.72 333.62,352.72 334.22,353.26 334.22,354.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "330.67,352.02 332.4,352.02 333.62,352.72 333.62,353.72 332.4,354.42  330.67,354.42 329.45,353.72 329.45,352.72  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "329.23,353.27 329.23,353.86 330.58,354.65 331.06,353.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "330.58,354.06 330.58,354.65 332.5,354.65 333.85,353.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "332.5,354.06 332.5,354.65 333.85,353.86 333.85,353.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "333.85,352.17 333.85,353.27 332.5,354.06 330.58,354.06 329.23,353.27  329.23,352.17 330.58,351.39 332.5,351.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "329.83,351.04 329.83,353.06 330.83,353.63 331.18,351.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "330.83,351.62 330.83,353.63 332.25,353.63 333.24,351.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "332.25,351.62 332.25,353.63 333.24,353.06 333.24,351.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "333.24,350.22 333.24,351.04 332.24,351.62 330.83,351.62 329.83,351.04  329.83,350.22 330.83,349.65 332.24,349.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "334.22,356.49 334.22,359.68 332.65,360.58 332.65,357.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.42,
    y: 357.4,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "329.63,356.95 329.63,360.13 330.42,360.58 330.42,357.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "331.05,362.3 331.05,369.97 332.62,370.88 333.18,362.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "332.62,363.2 332.62,370.88 334.85,370.88 336.42,362.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "334.85,363.2 334.85,370.88 336.42,369.97 336.42,367.43 335.64,366.52  336.42,364.25 336.42,362.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "332.87,362.18 334.6,362.18 334.85,363.2 332.62,363.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "331.65,361.47 332.87,362.18 332.62,363.2 331.05,362.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "331.65,360.47 331.65,361.47 331.05,362.3 331.05,361.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "334.6,362.18 335.82,361.47 336.42,362.3 334.85,363.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "335.82,361.47 335.82,360.47 336.42,361.01 336.42,362.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "332.87,359.77 334.6,359.77 335.82,360.47 335.82,361.47 334.6,362.18  332.87,362.18 331.65,361.47 331.65,360.47  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "331.42,361.03 331.42,361.62 332.77,362.4 333.25,361.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "332.78,361.81 332.77,362.4 334.69,362.4 336.04,361.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "334.69,361.81 334.69,362.4 336.04,361.62 336.04,361.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "336.04,359.92 336.04,361.03 334.68,361.81 332.77,361.81 331.42,361.03  331.42,359.92 332.77,359.14 334.68,359.14  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "332.03,358.79 332.03,360.81 333.03,361.39 333.38,359.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "333.03,359.37 333.03,361.39 334.44,361.39 335.43,358.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "334.44,359.37 334.44,361.39 335.44,360.81 335.43,358.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "335.44,357.98 335.43,358.79 334.43,359.37 333.03,359.37 332.03,358.79  332.03,357.98 333.03,357.4 334.43,357.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "336.42,364.25 336.42,367.43 334.84,368.34 334.84,365.16  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 365.16,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.22,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "331.83,364.7 331.83,367.88 332.62,368.34 332.62,365.16  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "337.19,356.53 337.19,364.2 338.77,365.11 339.32,357.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "338.77,357.44 338.77,365.11 340.99,365.11 342.57,356.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "340.99,357.44 340.99,365.11 342.57,364.2 342.57,361.66 341.79,360.75  342.57,358.48 342.57,356.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "339.02,356.41 340.74,356.41 340.99,357.44 338.77,357.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "337.79,355.71 339.02,356.41 338.77,357.44 337.19,356.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "337.79,354.71 337.79,355.71 337.19,356.53 337.19,355.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "340.74,356.41 341.96,355.71 342.57,356.53 340.99,357.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "341.96,355.71 341.97,354.71 342.57,355.24 342.57,356.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "339.02,354 340.74,354 341.97,354.71 341.96,355.71 340.74,356.41 339.02,356.41  337.79,355.71 337.79,354.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "337.57,355.26 337.57,355.85 338.92,356.63 339.4,355.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "338.92,356.04 338.92,356.63 340.83,356.63 342.19,355.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "340.83,356.04 340.83,356.63 342.19,355.85 342.19,355.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "342.19,354.16 342.19,355.26 340.83,356.04 338.92,356.04 337.57,355.26  337.57,354.16 338.92,353.38 340.83,353.38  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "338.18,353.03 338.18,355.04 339.18,355.62 339.53,353.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "339.18,353.6 339.18,355.62 340.58,355.62 341.58,353.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "340.58,353.6 340.58,355.62 341.58,355.04 341.58,353.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "341.58,352.21 341.58,353.03 340.58,353.6 339.18,353.6 338.18,353.03  338.18,352.21 339.17,351.64 340.58,351.64  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "342.57,358.48 342.57,361.66 340.99,362.57 340.98,359.39  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.76,
    y: 359.39,
    transform: "matrix(1 -1.541945e-03 1.541945e-03 1 -0.5562 0.5245)",
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "337.98,358.94 337.98,362.12 338.76,362.57 338.76,359.39  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "343.54,366.71 343.54,374.38 345.12,375.29 345.67,367.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "345.12,367.61 345.12,375.29 347.34,375.29 348.91,366.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "347.34,367.61 347.34,375.29 348.91,374.38 348.91,371.84 348.14,370.93  348.91,368.66 348.91,366.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "345.37,366.59 347.09,366.59 347.34,367.61 345.12,367.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "344.14,365.88 345.37,366.59 345.12,367.61 343.54,366.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "344.14,364.88 344.14,365.88 343.54,366.71 343.54,365.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "347.09,366.59 348.31,365.88 348.91,366.71 347.34,367.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "348.31,365.88 348.31,364.88 348.91,365.42 348.91,366.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "345.37,364.18 347.09,364.18 348.31,364.88 348.31,365.88 347.09,366.59  345.37,366.59 344.14,365.88 344.14,364.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "343.92,365.43 343.92,366.03 345.27,366.81 345.75,365.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "345.27,366.22 345.27,366.81 347.19,366.81 348.54,365.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "347.19,366.22 347.19,366.81 348.54,366.03 348.54,365.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "348.54,364.33 348.54,365.43 347.18,366.22 345.27,366.22 343.91,365.43  343.91,364.33 345.27,363.55 347.18,363.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "344.52,363.2 344.52,365.22 345.52,365.8 345.87,363.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "345.52,363.78 345.52,365.8 346.93,365.8 347.93,363.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "346.93,363.78 346.93,365.8 347.93,365.22 347.93,363.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "347.93,362.39 347.93,363.2 346.93,363.78 345.52,363.78 344.52,363.2  344.52,362.39 345.52,361.81 346.93,361.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "348.91,368.66 348.91,371.84 347.34,372.75 347.34,369.56  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.11,
    y: 369.56,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "344.33,369.11 344.33,372.3 345.11,372.75 345.11,369.56  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "351.35,364.9 351.35,372.57 352.92,373.48 353.48,365.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "352.92,365.81 352.92,373.48 355.15,373.48 356.72,364.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "355.15,365.81 355.15,373.48 356.72,372.57 356.72,370.04 355.94,369.13  356.72,366.85 356.72,364.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "353.17,364.78 354.9,364.78 355.15,365.81 352.92,365.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "351.95,364.08 353.17,364.78 352.92,365.81 351.35,364.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "351.95,363.08 351.95,364.08 351.35,364.9 351.35,363.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "354.9,364.78 356.12,364.08 356.72,364.9 355.15,365.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "356.12,364.08 356.12,363.08 356.72,363.62 356.72,364.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "353.17,362.38 354.9,362.38 356.12,363.08 356.12,364.08 354.9,364.78  353.17,364.78 351.95,364.08 351.95,363.08  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "351.72,363.63 351.72,364.22 353.08,365 353.55,364.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "353.08,364.42 353.08,365 354.99,365 356.34,363.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "354.99,364.42 354.99,365 356.34,364.22 356.34,363.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "356.34,362.53 356.34,363.63 354.99,364.42 353.08,364.42 351.72,363.63  351.72,362.53 353.08,361.75 354.99,361.75  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "352.33,361.4 352.33,363.42 353.33,363.99 353.68,361.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "353.33,361.98 353.33,363.99 354.74,363.99 355.73,361.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "354.74,361.98 354.74,363.99 355.74,363.42 355.73,361.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "355.74,360.58 355.73,361.4 354.74,361.98 353.33,361.98 352.33,361.4  352.33,360.58 353.33,360.01 354.74,360.01  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "356.72,366.85 356.72,370.04 355.14,370.94 355.14,367.76  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.92,
    y: 367.76,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "352.14,367.31 352.14,370.49 352.92,370.94 352.92,367.76  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "351.35,376.97 351.35,384.65 352.92,385.55 353.48,377.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "352.92,377.88 352.92,385.55 355.15,385.55 356.72,376.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "355.15,377.88 355.15,385.55 356.72,384.65 356.72,382.1 355.94,381.2  356.72,378.92 356.72,376.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "353.17,376.85 354.9,376.85 355.15,377.88 352.92,377.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F3D"
    },
    points: "351.95,376.15 353.17,376.85 352.92,377.88 351.35,376.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E1C"
    },
    points: "351.95,375.15 351.95,376.15 351.35,376.97 351.35,375.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD293"
    },
    points: "354.9,376.85 356.12,376.15 356.72,376.97 355.15,377.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB053"
    },
    points: "356.12,376.15 356.12,375.15 356.72,375.68 356.72,376.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A7147"
    },
    points: "353.17,374.44 354.9,374.44 356.12,375.15 356.12,376.15 354.9,376.85  353.17,376.85 351.95,376.15 351.95,375.15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "351.73,375.7 351.73,376.29 353.08,377.07 353.55,376.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "353.08,376.48 353.08,377.07 354.99,377.07 356.34,375.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "354.99,376.48 354.99,377.07 356.35,376.29 356.34,375.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "356.35,374.59 356.34,375.7 354.99,376.48 353.08,376.48 351.72,375.7  351.72,374.59 353.08,373.81 354.99,373.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "352.33,373.46 352.33,375.48 353.33,376.06 353.68,373.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "353.33,374.04 353.33,376.06 354.74,376.06 355.74,373.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "354.74,374.04 354.74,376.06 355.74,375.48 355.74,373.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "355.74,372.65 355.74,373.46 354.74,374.04 353.33,374.04 352.33,373.46  352.33,372.65 353.33,372.08 354.74,372.08  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "356.72,378.92 356.72,382.1 355.15,383.01 355.14,379.83  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.92,
    y: 379.83,
    style: {
      fill: "#F4EFE9"
    },
    width: 2.23,
    height: 3.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "352.14,379.37 352.14,382.55 352.92,383.01 352.92,379.83  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "184.23,195.65 184.23,223.14 146.23,245.11 135.4,220.38 146.35,216.78  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "238.81,238.92 217.09,226.36 186.35,226.36 164.62,238.92 164.62,256.66  186.35,269.21 217.09,269.21 238.81,256.66  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.35,
    y: 269.21,
    style: {
      fill: "#B5AFA7"
    },
    width: 30.73,
    height: 2.22
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "238.81,258.89 217.09,271.43 217.09,269.21 238.81,256.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "164.62,258.89 186.35,271.43 186.35,269.21 164.62,256.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "236.83,243.72 236.83,255.86 216.26,267.72 208.99,251.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "216.26,255.61 216.26,267.72 187.18,267.72 166.61,243.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "187.18,255.61 187.18,267.72 166.6,255.86 166.61,243.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "213.01,242.19 190.44,242.19 187.18,255.61 216.26,255.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5AFA7"
    },
    points: "228.99,232.96 213.01,242.19 216.26,255.61 236.83,243.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "228.99,219.92 228.99,232.96 236.83,243.72 236.85,226.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "190.44,242.19 174.46,232.96 166.61,243.73 187.18,255.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "174.46,232.96 174.45,219.92 166.6,226.93 166.61,243.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDE8E3"
    },
    points: "213.01,210.71 190.44,210.71 174.45,219.92 174.46,232.96 190.44,242.19  213.01,242.19 228.99,232.96 228.99,219.92  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "253.36,224.76 253.36,235.22 215.36,257.19 215.36,246.72 215.48,245.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8D1C7"
    },
    points: "215.36,246.72 215.36,257.19 146.25,217.39 146.23,245.11 130.61,236.05 130.61,197.8  172.21,221.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E1DD"
    },
    points: "253.36,224.76 168.62,175.84 130.61,197.8 215.36,246.72  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "41.42,295.26 52.97,290.59 69.31,290.59 80.86,295.26 80.86,301.86 69.31,306.53  52.97,306.53 41.42,301.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "43.14,235.9 42.17,236.97 39.75,237.3 38.07,236.94 36.71,240.29 36.71,242.72  37.91,245.36 40.12,246.3 41.19,245.36 40.97,242.72 41.98,240.22  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D18067"
    },
    points: "34.51,257.04 34.33,256.94 34.33,245.18 34.83,244.31 48.02,236.69 48.2,236.79  48.2,248.55 47.7,249.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#853E2A"
    },
    points: "35.01,257.33 34.51,257.04 34.51,245.28 35.01,244.41 48.2,236.79 48.71,237.08  48.71,248.84 48.2,249.71  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "35.45,256.23 48.36,248.78 48.36,237.5 35.45,244.95  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A39C95"
    },
    points: "47.85,245.09 47.68,244.98 47.68,242.46 48.19,241.59 48.71,241.29 48.71,241.01  49.13,241.25 49.12,243.77 48.62,244.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4EFE9"
    },
    points: "48.35,245.38 47.85,245.09 47.86,242.57 48.36,241.7 49.13,241.25 49.64,241.54  49.63,244.06 49.12,244.94  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#418080"
    },
    points: "71.59,295.32 75.18,295.78 78.85,295.67 79.73,299 79.73,299.68 76.38,301.46  70.3,302.24 67,303.16 64.64,303.16 63.09,301.82 63.09,301.14 65.87,296.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#418080"
    },
    points: "54,293.34 54,294.03 53.73,295.68 51.59,298.12 50.97,300.65 49.51,302.99 46.52,302.99  46.1,299.97 46.1,299.29 49.15,293.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "71.59,294.64 75.18,295.1 78.85,294.98 79.73,296.17 79.73,299 76.38,300.78 70.3,301.56  67,302.48 64.64,302.48 63.09,301.14 63.37,297.07 65.87,295.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "53.46,292.4 54,293.34 53.73,295 51.59,297.43 50.97,299.97 49.51,302.31 46.52,302.31  46.1,299.29 46.19,295.01 49.15,293.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "42.75,234.79 43.14,235.9 42.95,237.26 41.03,238.09 38.89,238.09 38.07,236.94  37.97,236.03 39.41,235.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "49.95,202.57 44.97,201.98 42.75,202.89 40.98,204.43 39.77,206.7 38.82,210.26  34.27,223.36 35.51,232.91 37.52,234.28 37.97,236.03 39.73,236.36 42.11,235.9 42.85,234.62 42.37,232.56 43.5,231.01  42.31,222.37 45.44,216.67 51.23,209.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "45.44,216.67 44.66,218.08 43.37,213.59 44.28,208.39 46.31,213.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "42.31,222.37 37.59,222.93 38.56,223.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "37.52,234.28 39.54,234.62 41.98,233.14 39.87,234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "59.83,250.37 56.95,267.55 55.59,272.29 53.46,294.9 50.43,297.76 46.96,297.15  45.84,294.04 45.84,276.71 48.01,267.35 46.96,243.09 61.09,245.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "58.94,255.66 57.92,247.77 60,250.76 59.34,253.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "72.7,245.26 73,256.56 72.42,269.56 71.66,294.47 70.62,297.24 66.72,298.63 62.8,296.81  61.87,278.27 63.25,271.07 58.49,249.43 62.8,244.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "61.3,199.71 61.07,201.13 60.29,202.61 57.69,203.22 53.59,202.59 52.51,201.29  51.65,199.51 51.97,197.86 53.03,196.29 57.75,195.77 61.95,198.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "61.17,204.54 61.17,201.12 58.01,201.72 53.6,201.12 51.65,199.51 51.36,201.36  50.52,202.37 50.16,203.73 51.85,206.4 56.14,207.34 60.3,207.34 61.86,205.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "72.7,245.26 70.75,248.55 67.7,249.84 63.38,250.37 54.11,248.59 47.74,246.04  46.96,243.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "70.53,210.04 65.87,207.05 61.17,204.54 60.74,205.67 57.98,206.4 53.03,205.4  50.52,202.37 46.96,203.58 44.28,208.39 44.28,213.64 45.84,217.71 47.23,226.93 47.31,238.24 46.96,243.09 47.92,245.17  54.76,248.03 63.34,249.59 67.41,248.99 70.53,247.95 72.7,245.26 71.74,228.88 71.57,220.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "71.61,222.33 71.66,224.61 65.87,219.72 70.36,219.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "87.49,206.4 88.21,204.93 88.9,204.54 90.41,204.54 91.53,205.47 92.23,206.87 92,207.55  91.31,208.78 89.13,207.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0C6B4"
    },
    points: "65.57,189.7 65.7,191 65.1,191.87 65.51,192.99 64.86,195.42 62.97,199.8 61.3,199.71  60.09,198.32 59.9,197 61.52,188.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6E5849"
    },
    points: "66.03,188.45 65.56,190.54 64.25,191.97 63.94,193.5 63.51,194.09 62.87,192.89  62.31,193.31 62.22,195.48 61.15,197.74 59.27,199.34 57.36,199.97 54.24,199.68 51.3,197.39 49.87,193.27 49.26,190.24  49.48,187.86 50.91,184.91 53.07,182.88 55.5,181.88 57.97,181.54 61.09,181.54 63.6,183.01 63.08,183.1 65.59,185 65.29,185.31  66.76,187.38 66.54,188.97  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "64.98,193.36 63,193.11 63.28,193.64 64.98,193.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0DEDC"
    },
    points: "62.88,198.8 63.67,193.23 63.47,193.52 62.55,198.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "65.51,192.99 64.56,193.33 64.73,194.13 63.22,198.31 62.55,198.77 63.24,199.51  65.34,195.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7DD2E3"
    },
    points: "63.97,211.27 66.76,209.46 70.53,210.04 73.91,212.77 80.8,217.06 84.37,208.87  86.12,208.48 87.49,206.4 88.72,206.4 90.41,207.12 91.32,208.74 90.74,210.56 91.71,212.25 86.65,223.23 81.64,226.93  70.82,221.96 65.87,219.72 63.19,216.67 62.8,213.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "80.8,217.06 83.82,221.15 84.18,219.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CB5C4"
    },
    points: "90.74,210.56 89.32,208.61 86.47,208.39 88.81,209.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "92,207.55 91.39,205.92 89.85,204.95 88.21,204.93 90.74,198.26 92.84,195.29  95.42,194.55 95.96,194.75 95.72,195.48 94.14,196.42 92.91,198.19 94.61,196.93 96.15,197.69 97.28,201.18 97.09,202.37  96.13,202.83 93.07,206.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#7DD2E3"
    },
    points: "66.22,190.35 64.64,192.1 63.69,194.28 62.8,195.7 61.3,197.96 60.48,198.77  59.62,200.43 58.57,200.73 56.58,201.12 53.72,200.68 52.29,199.8 51.08,198.56 50.04,196.65 49.26,193.97 48.87,191.46  48.87,189.55 49.26,186.82 50.21,184.78 51.86,183.14 54.29,181.54 56.75,181.02 58.84,180.8 61.78,181.23 64.07,182.66  65.7,184.13 66.76,186.13 67.09,188.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAF3FF"
    },
    points: "41.98,240.22 42.59,240.68 42.59,242.79 43.24,243.57 44.28,242.46 44.28,238.96  43.14,235.9 40.72,239.73  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodbeverage);
export default __webpack_public_path__ + "static/media/foodbeverage.d721d7b4dd0dad8fd60fef390cfb8b2b.svg";
export { ForwardRef as ReactComponent };